import {
  EmptySerializersModule991ju6pz9b79 as EmptySerializersModule,
  StringFormat2r2ka8mzcb3mi as StringFormat,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  serializer1x79l67jvwntn as serializer,
  InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor,
  SEALED_getInstance15u0wl5f5h4qk as SEALED_getInstance,
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  KSerializerzf77vz1967fq as KSerializer,
  STRING_getInstance2gbamclnmtzqa as STRING_getInstance,
  ENUM_getInstance3doea03ve3rgg as ENUM_getInstance,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  serializer2lw83vwvpnyms as serializer_0,
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
  ElementMarker33ojvsajwmzts as ElementMarker,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  SerializationException_init_$Init$2mbwpyyvgkydo as SerializationException_init_$Init$,
  SerializationException_init_$Create$1byppqmdb64jn as SerializationException_init_$Create$,
  CLASS_getInstance1ss90e870vddp as CLASS_getInstance,
  LIST_getInstance3iji3zetpdcxm as LIST_getInstance,
  CONTEXTUAL_getInstance40twmib99zqv as CONTEXTUAL_getInstance,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  MAP_getInstance2l4ulrz8ljw5i as MAP_getInstance,
  ENUMlmq49cvwy4ow as ENUM,
  contextual3hpp1gupsu4al as contextual,
  SerializersModuleCollector3dddz14wd7brg as SerializersModuleCollector,
  SealedClassSerializeriwipiibk55zc as SealedClassSerializer,
  jsonCachedSerialNameslxufy2gu43jt as jsonCachedSerialNames,
  AbstractDecoder35guh02ubh2hm as AbstractDecoder,
  AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer,
  DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy,
  findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer,
  MissingFieldException24tqif29emcmi as MissingFieldException,
  AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder,
  OBJECT_getInstancee89a3hlgr5ys as OBJECT_getInstance,
  findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer_0,
  SerializationStrategyh6ouydnm6hci as SerializationStrategy,
  serializer3ikrxnm8b29d6 as serializer_1,
  serializer36584sjyg5661 as serializer_2,
  serializer1q7c5q67ysppr as serializer_3,
  NamedValueDecoderzk26ztf92xbq as NamedValueDecoder,
  getContextualDescriptor2n1gf3b895yb8 as getContextualDescriptor,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  Unit_instance104q5opgivhr8 as Unit_instance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString1pkumu07cwy4m as toString,
  IllegalArgumentException_init_$Create$310sysrobvll9 as IllegalArgumentException_init_$Create$,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  _Char___init__impl__6a9atx281r2pd9o601g as _Char___init__impl__6a9atx,
  equals2au1ep9vhcato as equals,
  toString30pk9tzaqopn as toString_0,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  hashCodeq5arwsb9dgti as hashCode,
  joinToString1cxrrlmo0chqs as joinToString,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KtList3hktaavzmj137 as KtList,
  StringBuilder_init_$Create$2mwec1027v00x as StringBuilder_init_$Create$,
  KtMap140uvy3s5zad8 as KtMap,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toDouble1kn912gjoizjp as toDouble,
  StringCompanionObject_instance2odz3s3zbrixa as StringCompanionObject_instance,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$,
  LinkedHashMap_init_$Create$1p3p95clvi93w as LinkedHashMap_init_$Create$,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  toULongOrNullojoyxi0i9tgj as toULongOrNull,
  ULong3f9k7s38t3rfp as ULong,
  Companion_getInstance1poxudqc1ru3p as Companion_getInstance,
  _ULong___get_data__impl__fggpzb1jl4xe0gulani as _ULong___get_data__impl__fggpzb,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  toBooleanStrictOrNull2j0md398tkvbj as toBooleanStrictOrNull,
  isInterface3d6p8outrmvmk as isInterface,
  IllegalStateException_init_$Create$3ib9qa3pip8n4 as IllegalStateException_init_$Create$,
  lazy2hsh8ze7j6ikd as lazy,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  toLongw1zpgk99d84b as toLong,
  _UInt___init__impl__l7qpdl1vpobek1e692 as _UInt___init__impl__l7qpdl,
  UInt__toString_impl_dbgl212oeqkp5cl059g as UInt__toString_impl_dbgl21,
  _ULong___init__impl__c78o9k2uqxdjm6b0lbg as _ULong___init__impl__c78o9k,
  ULong__toString_impl_f9au7k2b7ohj6omvcs4 as ULong__toString_impl_f9au7k,
  _UByte___init__impl__g9hnc415bxbmye0j11o as _UByte___init__impl__g9hnc4,
  UByte__toString_impl_v72jgd49yaowf0kue as UByte__toString_impl_v72jg,
  _UShort___init__impl__jigrne3h2nm35iaibum as _UShort___init__impl__jigrne,
  UShort__toString_impl_edaoee1aumkcln5sauo as UShort__toString_impl_edaoee,
  captureStack1fzi4aczwc4hg as captureStack,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
  Collection1k04j3hzsbod0 as Collection,
  singleOrNullrknfaxokm1sl as singleOrNull,
  emptyMapr06gerzljqtm as emptyMap,
  getValue48kllevslyh6 as getValue,
  copyOf2ng0t8oizk6it as copyOf,
  copyOf3rutauicler23 as copyOf_0,
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  DeepRecursiveScope1pqaydvh4vdcu as DeepRecursiveScope,
  Unitkvevlwgzwiuc as Unit,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  getKClass1s3j9wy1cofik as getKClass,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  substringBefore3n7kj60w69hju as substringBefore,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  substringAfter1hku067gwr5ve as substringAfter,
  contains3ue2qo8xhmpf1 as contains,
  plus17rl43at52ays as plus,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
  toUInt21lx0mz8wkp7c as toUInt,
  _UInt___get_data__impl__f0vqqw9xdox7iecbly as _UInt___get_data__impl__f0vqqw,
  toULong266mnyksbttkw as toULong,
  toUByteh6p4wmqswkrs as toUByte,
  _UByte___get_data__impl__jof9qrfj1ch8mjizvj as _UByte___get_data__impl__jof9qr,
  toUShort7yqspfnhrot4 as toUShort,
  _UShort___get_data__impl__g02459z5yfs6z0kj0 as _UShort___get_data__impl__g0245,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  toString35i91qxh73cps as toString_1,
  Companion_getInstance1z323tr26bmxd as Companion_getInstance_0,
  Companion_getInstance374brtr06v94p as Companion_getInstance_1,
  Companion_getInstanceojp2cj59jqir as Companion_getInstance_2,
  setOf45ia9pnfhe90 as setOf,
  Char__toInt_impl_vasixd2xlaiz5u3itpv as Char__toInt_impl_vasixd,
  numberToChar93r9buh19yek as numberToChar,
  equals2v6cggk171b6e as equals_0,
  toByte4i43936u611k as toByte,
  startsWith26w8qjqapeeq6 as startsWith,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  ClosedRangehokgr73im9z3 as ClosedRange,
  contains2c50nlxg7en7o as contains_0,
  single29ec4rh52687r as single,
  Char19o2r8palgjof as Char,
  emptySetcxexqki71qfa as emptySet,
  plus1ogy4liedzq5j as plus_0,
  toInt2q8uldh7sc951 as toInt,
  toList3jhuyej2anx2q as toList,
  enumEntries20mr21zbe3az4 as enumEntries,
  last1vo29oleiqj36 as last,
  removeLast3759euu1xvfa3 as removeLast,
  lastIndexOf2d52xhix5ymjr as lastIndexOf,
  Long2qws0ah9gnpki as Long,
  Char__minus_impl_a2frrhem8aw2sny2of as Char__minus_impl_a2frrh,
  numberToLong1a4cndvg6c52s as numberToLong,
  charArray2ujmm1qusno00 as charArray,
  indexOfwa4w6635jewi as indexOf,
  indexOf1xbs558u7wr52 as indexOf_0,
  StringBuilder_init_$Create$23o1ixl6cos5l as StringBuilder_init_$Create$_0,
  HashMap_init_$Create$3k4af1a3fibv9 as HashMap_init_$Create$,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(Json, 'Json', VOID, VOID, [StringFormat]);
initMetadataForObject(Default, 'Default', VOID, Json);
initMetadataForClass(JsonBuilder, 'JsonBuilder');
initMetadataForClass(JsonImpl, 'JsonImpl', VOID, Json);
initMetadataForClass(JsonClassDiscriminator, 'JsonClassDiscriminator');
initMetadataForClass(JsonIgnoreUnknownKeys, 'JsonIgnoreUnknownKeys');
initMetadataForClass(JsonNames, 'JsonNames');
initMetadataForClass(JsonConfiguration, 'JsonConfiguration');
initMetadataForClass(ClassDiscriminatorMode, 'ClassDiscriminatorMode', VOID, Enum);
initMetadataForInterface(JsonDecoder, 'JsonDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForCompanion(Companion);
initMetadataForClass(JsonElement, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForClass(JsonPrimitive, 'JsonPrimitive', VOID, JsonElement, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
initMetadataForObject(JsonNull, 'JsonNull', VOID, JsonPrimitive, [JsonPrimitive, SerializerFactory], VOID, VOID, {0: JsonNullSerializer_getInstance});
initMetadataForCompanion(Companion_1);
initMetadataForClass(JsonArray, 'JsonArray', VOID, JsonElement, [JsonElement, KtList], VOID, VOID, {0: JsonArraySerializer_getInstance});
initMetadataForCompanion(Companion_2);
initMetadataForClass(JsonObject, 'JsonObject', VOID, JsonElement, [JsonElement, KtMap], VOID, VOID, {0: JsonObjectSerializer_getInstance});
initMetadataForClass(JsonLiteral, 'JsonLiteral', VOID, JsonPrimitive);
initMetadataForClass(JsonArrayBuilder, 'JsonArrayBuilder');
initMetadataForClass(JsonObjectBuilder, 'JsonObjectBuilder');
initMetadataForObject(JsonElementSerializer, 'JsonElementSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonNullSerializer, 'JsonNullSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonArrayDescriptor, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(JsonArraySerializer, 'JsonArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonObjectDescriptor, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(JsonObjectSerializer, 'JsonObjectSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonLiteralSerializer, 'JsonLiteralSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(defer$1, VOID, VOID, VOID, [SerialDescriptor]);
initMetadataForInterface(JsonEncoder, 'JsonEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
initMetadataForClass(Composer, 'Composer');
initMetadataForClass(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers', VOID, Composer);
initMetadataForClass(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals', VOID, Composer);
initMetadataForClass(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint', VOID, Composer);
initMetadataForClass(JsonElementMarker, 'JsonElementMarker');
initMetadataForClass(JsonException, 'JsonException', VOID, SerializationException);
initMetadataForClass(JsonDecodingException, 'JsonDecodingException', VOID, JsonException);
initMetadataForClass(JsonEncodingException, 'JsonEncodingException', VOID, JsonException);
initMetadataForObject(Tombstone, 'Tombstone');
initMetadataForClass(JsonPath, 'JsonPath', JsonPath);
initMetadataForClass(JsonSerializersModuleValidator, 'JsonSerializersModuleValidator', VOID, VOID, [SerializersModuleCollector]);
initMetadataForLambda(JsonTreeReader$readDeepRecursive$slambda, CoroutineImpl, VOID, [2]);
initMetadataForCoroutine($readObjectCOROUTINE$0, CoroutineImpl);
initMetadataForClass(JsonTreeReader, 'JsonTreeReader', VOID, VOID, VOID, [0]);
initMetadataForClass(Key, 'Key', Key);
initMetadataForClass(DescriptorSchemaCache, 'DescriptorSchemaCache', DescriptorSchemaCache);
initMetadataForClass(DiscriminatorHolder, 'DiscriminatorHolder');
initMetadataForClass(StreamingJsonDecoder, 'StreamingJsonDecoder', VOID, AbstractDecoder, [JsonDecoder, AbstractDecoder]);
initMetadataForClass(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes', VOID, AbstractDecoder);
initMetadataForClass(StreamingJsonEncoder, 'StreamingJsonEncoder', VOID, AbstractEncoder, [JsonEncoder, AbstractEncoder]);
initMetadataForClass(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', VOID, NamedValueDecoder, [NamedValueDecoder, JsonDecoder]);
initMetadataForClass(JsonTreeDecoder, 'JsonTreeDecoder', VOID, AbstractJsonTreeDecoder);
initMetadataForClass(JsonTreeListDecoder, 'JsonTreeListDecoder', VOID, AbstractJsonTreeDecoder);
initMetadataForClass(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder', VOID, AbstractJsonTreeDecoder);
initMetadataForClass(JsonTreeMapDecoder, 'JsonTreeMapDecoder', VOID, JsonTreeDecoder);
initMetadataForClass(WriteMode, 'WriteMode', VOID, Enum);
initMetadataForClass(AbstractJsonLexer, 'AbstractJsonLexer');
initMetadataForObject(CharMappings, 'CharMappings');
initMetadataForClass(StringJsonLexer, 'StringJsonLexer', VOID, AbstractJsonLexer);
initMetadataForClass(StringJsonLexerWithComments, 'StringJsonLexerWithComments', VOID, StringJsonLexer);
initMetadataForClass(JsonToStringWriter, 'JsonToStringWriter', JsonToStringWriter);
//endregion
function Default() {
  Default_instance = this;
  Json.call(this, new JsonConfiguration(), EmptySerializersModule());
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance == null)
    new Default();
  return Default_instance;
}
function Json(configuration, serializersModule) {
  Default_getInstance();
  this.p5z_1 = configuration;
  this.q5z_1 = serializersModule;
  this.r5z_1 = new DescriptorSchemaCache();
}
protoOf(Json).zr = function () {
  return this.q5z_1;
};
protoOf(Json).ap = function (serializer, value) {
  var result = new JsonToStringWriter();
  try {
    encodeByWriter(this, result, serializer, value);
    return result.toString();
  }finally {
    result.a28();
  }
};
protoOf(Json).bp = function (deserializer, string) {
  var lexer = StringJsonLexer_0(this, string);
  var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.xn(), null);
  var result = input.jr(deserializer);
  lexer.h60();
  return result;
};
protoOf(Json).s5z = function (deserializer, element) {
  return readJson(this, element, deserializer);
};
protoOf(Json).t5z = function (string) {
  return this.bp(JsonElementSerializer_getInstance(), string);
};
function Json_0(from, builderAction) {
  from = from === VOID ? Default_getInstance() : from;
  var builder = new JsonBuilder(from);
  builderAction(builder);
  var conf = builder.a61();
  return new JsonImpl(conf, builder.z60_1);
}
function JsonBuilder(json) {
  this.i60_1 = json.p5z_1.b61_1;
  this.j60_1 = json.p5z_1.g61_1;
  this.k60_1 = json.p5z_1.c61_1;
  this.l60_1 = json.p5z_1.d61_1;
  this.m60_1 = json.p5z_1.f61_1;
  this.n60_1 = json.p5z_1.h61_1;
  this.o60_1 = json.p5z_1.i61_1;
  this.p60_1 = json.p5z_1.k61_1;
  this.q60_1 = json.p5z_1.r61_1;
  this.r60_1 = json.p5z_1.m61_1;
  this.s60_1 = json.p5z_1.n61_1;
  this.t60_1 = json.p5z_1.o61_1;
  this.u60_1 = json.p5z_1.p61_1;
  this.v60_1 = json.p5z_1.q61_1;
  this.w60_1 = json.p5z_1.l61_1;
  this.x60_1 = json.p5z_1.e61_1;
  this.y60_1 = json.p5z_1.j61_1;
  this.z60_1 = json.zr();
}
protoOf(JsonBuilder).a61 = function () {
  if (this.y60_1) {
    // Inline function 'kotlin.require' call
    if (!(this.p60_1 === 'type')) {
      var message = 'Class discriminator should not be specified when array polymorphism is specified';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!this.q60_1.equals(ClassDiscriminatorMode_POLYMORPHIC_getInstance())) {
      var message_0 = 'useArrayPolymorphism option can only be used if classDiscriminatorMode in a default POLYMORPHIC state.';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
  }
  if (!this.m60_1) {
    // Inline function 'kotlin.require' call
    if (!(this.n60_1 === '    ')) {
      var message_1 = 'Indent should not be specified when default printing mode is used';
      throw IllegalArgumentException_init_$Create$(toString(message_1));
    }
  } else if (!(this.n60_1 === '    ')) {
    var tmp3 = this.n60_1;
    var tmp$ret$7;
    $l$block: {
      // Inline function 'kotlin.text.all' call
      var inductionVariable = 0;
      while (inductionVariable < charSequenceLength(tmp3)) {
        var element = charSequenceGet(tmp3, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
          tmp$ret$7 = false;
          break $l$block;
        }
      }
      tmp$ret$7 = true;
    }
    var allWhitespaces = tmp$ret$7;
    // Inline function 'kotlin.require' call
    if (!allWhitespaces) {
      var message_2 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.n60_1;
      throw IllegalArgumentException_init_$Create$(toString(message_2));
    }
  }
  return new JsonConfiguration(this.i60_1, this.k60_1, this.l60_1, this.x60_1, this.m60_1, this.j60_1, this.n60_1, this.o60_1, this.y60_1, this.p60_1, this.w60_1, this.r60_1, this.s60_1, this.t60_1, this.u60_1, this.v60_1, this.q60_1);
};
function validateConfiguration($this) {
  if (equals($this.zr(), EmptySerializersModule()))
    return Unit_instance;
  var collector = new JsonSerializersModuleValidator($this.p5z_1);
  $this.zr().t17(collector);
}
function JsonImpl(configuration, module_0) {
  Json.call(this, configuration, module_0);
  validateConfiguration(this);
}
function JsonClassDiscriminator() {
}
function JsonIgnoreUnknownKeys() {
}
function JsonNames() {
}
function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, allowComments, classDiscriminatorMode) {
  encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
  ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
  isLenient = isLenient === VOID ? false : isLenient;
  allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
  prettyPrint = prettyPrint === VOID ? false : prettyPrint;
  explicitNulls = explicitNulls === VOID ? true : explicitNulls;
  prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
  coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
  useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
  classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
  allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
  useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
  namingStrategy = namingStrategy === VOID ? null : namingStrategy;
  decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
  allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
  allowComments = allowComments === VOID ? false : allowComments;
  classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
  this.b61_1 = encodeDefaults;
  this.c61_1 = ignoreUnknownKeys;
  this.d61_1 = isLenient;
  this.e61_1 = allowStructuredMapKeys;
  this.f61_1 = prettyPrint;
  this.g61_1 = explicitNulls;
  this.h61_1 = prettyPrintIndent;
  this.i61_1 = coerceInputValues;
  this.j61_1 = useArrayPolymorphism;
  this.k61_1 = classDiscriminator;
  this.l61_1 = allowSpecialFloatingPointValues;
  this.m61_1 = useAlternativeNames;
  this.n61_1 = namingStrategy;
  this.o61_1 = decodeEnumsCaseInsensitive;
  this.p61_1 = allowTrailingComma;
  this.q61_1 = allowComments;
  this.r61_1 = classDiscriminatorMode;
}
protoOf(JsonConfiguration).toString = function () {
  return 'JsonConfiguration(encodeDefaults=' + this.b61_1 + ', ignoreUnknownKeys=' + this.c61_1 + ', isLenient=' + this.d61_1 + ', ' + ('allowStructuredMapKeys=' + this.e61_1 + ', prettyPrint=' + this.f61_1 + ', explicitNulls=' + this.g61_1 + ', ') + ("prettyPrintIndent='" + this.h61_1 + "', coerceInputValues=" + this.i61_1 + ', useArrayPolymorphism=' + this.j61_1 + ', ') + ("classDiscriminator='" + this.k61_1 + "', allowSpecialFloatingPointValues=" + this.l61_1 + ', ') + ('useAlternativeNames=' + this.m61_1 + ', namingStrategy=' + toString_0(this.n61_1) + ', decodeEnumsCaseInsensitive=' + this.o61_1 + ', ') + ('allowTrailingComma=' + this.p61_1 + ', allowComments=' + this.q61_1 + ', classDiscriminatorMode=' + this.r61_1.toString() + ')');
};
var ClassDiscriminatorMode_NONE_instance;
var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
var ClassDiscriminatorMode_POLYMORPHIC_instance;
var ClassDiscriminatorMode_entriesInitialized;
function ClassDiscriminatorMode_initEntries() {
  if (ClassDiscriminatorMode_entriesInitialized)
    return Unit_instance;
  ClassDiscriminatorMode_entriesInitialized = true;
  ClassDiscriminatorMode_NONE_instance = new ClassDiscriminatorMode('NONE', 0);
  ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new ClassDiscriminatorMode('ALL_JSON_OBJECTS', 1);
  ClassDiscriminatorMode_POLYMORPHIC_instance = new ClassDiscriminatorMode('POLYMORPHIC', 2);
}
function ClassDiscriminatorMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ClassDiscriminatorMode_NONE_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_NONE_instance;
}
function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_POLYMORPHIC_instance;
}
function JsonDecoder() {
}
function get_jsonUnquotedLiteralDescriptor() {
  _init_properties_JsonElement_kt__7cbdc2();
  return jsonUnquotedLiteralDescriptor;
}
var jsonUnquotedLiteralDescriptor;
function Companion() {
}
var Companion_instance;
function Companion_getInstance_3() {
  return Companion_instance;
}
function JsonElement() {
}
function Companion_0() {
}
var Companion_instance_0;
function Companion_getInstance_4() {
  return Companion_instance_0;
}
function JsonPrimitive() {
  JsonElement.call(this);
}
protoOf(JsonPrimitive).toString = function () {
  return this.z4u();
};
function JsonPrimitive_0(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new JsonLiteral(value, true);
}
function JsonPrimitive_1(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new JsonLiteral(value, false);
}
function JsonPrimitive_2(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new JsonLiteral(value, false);
}
function JsonNull() {
  JsonNull_instance = this;
  JsonPrimitive.call(this);
  this.u61_1 = 'null';
}
protoOf(JsonNull).z4u = function () {
  return this.u61_1;
};
protoOf(JsonNull).v61 = function () {
  return JsonNullSerializer_getInstance();
};
protoOf(JsonNull).a10 = function (typeParamsSerializers) {
  return this.v61();
};
var JsonNull_instance;
function JsonNull_getInstance() {
  if (JsonNull_instance == null)
    new JsonNull();
  return JsonNull_instance;
}
function Companion_1() {
}
var Companion_instance_1;
function Companion_getInstance_5() {
  return Companion_instance_1;
}
function JsonArray(content) {
  JsonElement.call(this);
  this.w61_1 = content;
}
protoOf(JsonArray).equals = function (other) {
  return equals(this.w61_1, other);
};
protoOf(JsonArray).hashCode = function () {
  return hashCode(this.w61_1);
};
protoOf(JsonArray).toString = function () {
  return joinToString(this.w61_1, ',', '[', ']');
};
protoOf(JsonArray).p = function () {
  return this.w61_1.p();
};
protoOf(JsonArray).x61 = function (element) {
  return this.w61_1.u1(element);
};
protoOf(JsonArray).u1 = function (element) {
  if (!(element instanceof JsonElement))
    return false;
  return this.x61(element instanceof JsonElement ? element : THROW_CCE());
};
protoOf(JsonArray).j = function () {
  return this.w61_1.j();
};
protoOf(JsonArray).y61 = function (elements) {
  return this.w61_1.v1(elements);
};
protoOf(JsonArray).v1 = function (elements) {
  return this.y61(elements);
};
protoOf(JsonArray).o = function (index) {
  return this.w61_1.o(index);
};
protoOf(JsonArray).z61 = function (element) {
  return this.w61_1.w1(element);
};
protoOf(JsonArray).w1 = function (element) {
  if (!(element instanceof JsonElement))
    return -1;
  return this.z61(element instanceof JsonElement ? element : THROW_CCE());
};
protoOf(JsonArray).q = function (index) {
  return this.w61_1.q(index);
};
protoOf(JsonArray).x1 = function (fromIndex, toIndex) {
  return this.w61_1.x1(fromIndex, toIndex);
};
protoOf(JsonArray).m = function () {
  return this.w61_1.m();
};
function get_jsonArray(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonArray ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    error(_this__u8e3s4, 'JsonArray');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function get_contentOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp;
  if (_this__u8e3s4 instanceof JsonNull) {
    tmp = null;
  } else {
    tmp = _this__u8e3s4.z4u();
  }
  return tmp;
}
function Companion_2() {
}
var Companion_instance_2;
function Companion_getInstance_6() {
  return Companion_instance_2;
}
function JsonObject$toString$lambda(_destruct__k2r9zo) {
  // Inline function 'kotlin.collections.component1' call
  var k = _destruct__k2r9zo.s();
  // Inline function 'kotlin.collections.component2' call
  var v = _destruct__k2r9zo.t();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  printQuoted(this_0, k);
  this_0.c8(_Char___init__impl__6a9atx(58));
  this_0.a8(v);
  return this_0.toString();
}
function JsonObject(content) {
  JsonElement.call(this);
  this.a62_1 = content;
}
protoOf(JsonObject).equals = function (other) {
  return equals(this.a62_1, other);
};
protoOf(JsonObject).hashCode = function () {
  return hashCode(this.a62_1);
};
protoOf(JsonObject).toString = function () {
  var tmp = this.a62_1.r();
  return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
};
protoOf(JsonObject).p = function () {
  return this.a62_1.p();
};
protoOf(JsonObject).c3p = function (key) {
  return this.a62_1.y1(key);
};
protoOf(JsonObject).y1 = function (key) {
  if (!(!(key == null) ? typeof key === 'string' : false))
    return false;
  return this.c3p((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
};
protoOf(JsonObject).h2a = function (key) {
  return this.a62_1.a2(key);
};
protoOf(JsonObject).a2 = function (key) {
  if (!(!(key == null) ? typeof key === 'string' : false))
    return null;
  return this.h2a((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
};
protoOf(JsonObject).m = function () {
  return this.a62_1.m();
};
protoOf(JsonObject).b2 = function () {
  return this.a62_1.b2();
};
protoOf(JsonObject).c2 = function () {
  return this.a62_1.c2();
};
protoOf(JsonObject).r = function () {
  return this.a62_1.r();
};
function JsonLiteral(body, isString, coerceToInlineType) {
  coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
  JsonPrimitive.call(this);
  this.b62_1 = isString;
  this.c62_1 = coerceToInlineType;
  this.d62_1 = toString(body);
  if (!(this.c62_1 == null)) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.c62_1.pp()) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
}
protoOf(JsonLiteral).z4u = function () {
  return this.d62_1;
};
protoOf(JsonLiteral).toString = function () {
  var tmp;
  if (this.b62_1) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    printQuoted(this_0, this.d62_1);
    tmp = this_0.toString();
  } else {
    tmp = this.d62_1;
  }
  return tmp;
};
protoOf(JsonLiteral).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof JsonLiteral))
    THROW_CCE();
  if (!(this.b62_1 === other.b62_1))
    return false;
  if (!(this.d62_1 === other.d62_1))
    return false;
  return true;
};
protoOf(JsonLiteral).hashCode = function () {
  var result = getBooleanHashCode(this.b62_1);
  result = imul(31, result) + getStringHashCode(this.d62_1) | 0;
  return result;
};
function error(_this__u8e3s4, element) {
  _init_properties_JsonElement_kt__7cbdc2();
  throw IllegalArgumentException_init_$Create$('Element ' + toString(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
}
function get_booleanOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toBooleanStrictOrNull_0(_this__u8e3s4.z4u());
}
function parseLongImpl(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return (new StringJsonLexer(_this__u8e3s4.z4u())).e62();
}
function get_float(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlin.text.toFloat' call
  var this_0 = _this__u8e3s4.z4u();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return toDouble(this_0);
}
function get_double(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toDouble(_this__u8e3s4.z4u());
}
function get_jsonPrimitive(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    error(_this__u8e3s4, 'JsonPrimitive');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
var properties_initialized_JsonElement_kt_abxy8s;
function _init_properties_JsonElement_kt__7cbdc2() {
  if (!properties_initialized_JsonElement_kt_abxy8s) {
    properties_initialized_JsonElement_kt_abxy8s = true;
    jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
  }
}
function JsonArrayBuilder() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.f62_1 = ArrayList_init_$Create$();
}
protoOf(JsonArrayBuilder).g62 = function (element) {
  // Inline function 'kotlin.collections.plusAssign' call
  this.f62_1.e(element);
  return true;
};
protoOf(JsonArrayBuilder).a61 = function () {
  return new JsonArray(this.f62_1);
};
function JsonObjectBuilder() {
  var tmp = this;
  // Inline function 'kotlin.collections.linkedMapOf' call
  tmp.h62_1 = LinkedHashMap_init_$Create$();
}
protoOf(JsonObjectBuilder).i62 = function (key, element) {
  return this.h62_1.h2(key, element);
};
protoOf(JsonObjectBuilder).a61 = function () {
  return new JsonObject(this.h62_1);
};
function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
  $this$buildSerialDescriptor.io('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
  $this$buildSerialDescriptor.io('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
  $this$buildSerialDescriptor.io('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
  $this$buildSerialDescriptor.io('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
  $this$buildSerialDescriptor.io('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
  return Unit_instance;
}
function JsonElementSerializer$descriptor$lambda$lambda() {
  return JsonPrimitiveSerializer_getInstance().j62_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_0() {
  return JsonNullSerializer_getInstance().k62_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_1() {
  return JsonLiteralSerializer_getInstance().l62_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_2() {
  return JsonObjectSerializer_getInstance().m62_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_3() {
  return JsonArraySerializer_getInstance().n62_1;
}
function JsonElementSerializer() {
  JsonElementSerializer_instance = this;
  var tmp = this;
  var tmp_0 = SEALED_getInstance();
  tmp.o62_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
}
protoOf(JsonElementSerializer).xn = function () {
  return this.o62_1;
};
protoOf(JsonElementSerializer).p62 = function (encoder, value) {
  verify(encoder);
  if (value instanceof JsonPrimitive) {
    encoder.ct(JsonPrimitiveSerializer_getInstance(), value);
  } else {
    if (value instanceof JsonObject) {
      encoder.ct(JsonObjectSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonArray) {
        encoder.ct(JsonArraySerializer_getInstance(), value);
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
};
protoOf(JsonElementSerializer).yn = function (encoder, value) {
  return this.p62(encoder, value instanceof JsonElement ? value : THROW_CCE());
};
protoOf(JsonElementSerializer).zn = function (decoder) {
  var input = asJsonDecoder(decoder);
  return input.t61();
};
var JsonElementSerializer_instance;
function JsonElementSerializer_getInstance() {
  if (JsonElementSerializer_instance == null)
    new JsonElementSerializer();
  return JsonElementSerializer_instance;
}
function JsonPrimitiveSerializer() {
  JsonPrimitiveSerializer_instance = this;
  this.j62_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
}
protoOf(JsonPrimitiveSerializer).xn = function () {
  return this.j62_1;
};
protoOf(JsonPrimitiveSerializer).q62 = function (encoder, value) {
  verify(encoder);
  var tmp;
  if (value instanceof JsonNull) {
    encoder.ct(JsonNullSerializer_getInstance(), JsonNull_getInstance());
    tmp = Unit_instance;
  } else {
    var tmp_0 = JsonLiteralSerializer_getInstance();
    encoder.ct(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
    tmp = Unit_instance;
  }
  return tmp;
};
protoOf(JsonPrimitiveSerializer).yn = function (encoder, value) {
  return this.q62(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
};
protoOf(JsonPrimitiveSerializer).zn = function (decoder) {
  var result = asJsonDecoder(decoder).t61();
  if (!(result instanceof JsonPrimitive))
    throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + toString(getKClassFromExpression(result)), toString(result));
  return result;
};
var JsonPrimitiveSerializer_instance;
function JsonPrimitiveSerializer_getInstance() {
  if (JsonPrimitiveSerializer_instance == null)
    new JsonPrimitiveSerializer();
  return JsonPrimitiveSerializer_instance;
}
function JsonNullSerializer() {
  JsonNullSerializer_instance = this;
  this.k62_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
}
protoOf(JsonNullSerializer).xn = function () {
  return this.k62_1;
};
protoOf(JsonNullSerializer).r62 = function (encoder, value) {
  verify(encoder);
  encoder.fs();
};
protoOf(JsonNullSerializer).yn = function (encoder, value) {
  return this.r62(encoder, value instanceof JsonNull ? value : THROW_CCE());
};
protoOf(JsonNullSerializer).zn = function (decoder) {
  verify_0(decoder);
  if (decoder.vq()) {
    throw new JsonDecodingException("Expected 'null' literal");
  }
  decoder.wq();
  return JsonNull_getInstance();
};
var JsonNullSerializer_instance;
function JsonNullSerializer_getInstance() {
  if (JsonNullSerializer_instance == null)
    new JsonNullSerializer();
  return JsonNullSerializer_instance;
}
function JsonArrayDescriptor() {
  JsonArrayDescriptor_instance = this;
  this.s62_1 = ListSerializer(JsonElementSerializer_getInstance()).xn();
  this.t62_1 = 'kotlinx.serialization.json.JsonArray';
}
protoOf(JsonArrayDescriptor).yo = function () {
  return this.t62_1;
};
protoOf(JsonArrayDescriptor).sp = function (index) {
  return this.s62_1.sp(index);
};
protoOf(JsonArrayDescriptor).tp = function (name) {
  return this.s62_1.tp(name);
};
protoOf(JsonArrayDescriptor).up = function (index) {
  return this.s62_1.up(index);
};
protoOf(JsonArrayDescriptor).vp = function (index) {
  return this.s62_1.vp(index);
};
protoOf(JsonArrayDescriptor).wp = function (index) {
  return this.s62_1.wp(index);
};
protoOf(JsonArrayDescriptor).op = function () {
  return this.s62_1.op();
};
protoOf(JsonArrayDescriptor).kp = function () {
  return this.s62_1.kp();
};
protoOf(JsonArrayDescriptor).pp = function () {
  return this.s62_1.pp();
};
protoOf(JsonArrayDescriptor).qp = function () {
  return this.s62_1.qp();
};
protoOf(JsonArrayDescriptor).rp = function () {
  return this.s62_1.rp();
};
var JsonArrayDescriptor_instance;
function JsonArrayDescriptor_getInstance() {
  if (JsonArrayDescriptor_instance == null)
    new JsonArrayDescriptor();
  return JsonArrayDescriptor_instance;
}
function JsonArraySerializer() {
  JsonArraySerializer_instance = this;
  this.n62_1 = JsonArrayDescriptor_getInstance();
}
protoOf(JsonArraySerializer).xn = function () {
  return this.n62_1;
};
protoOf(JsonArraySerializer).u62 = function (encoder, value) {
  verify(encoder);
  ListSerializer(JsonElementSerializer_getInstance()).yn(encoder, value);
};
protoOf(JsonArraySerializer).yn = function (encoder, value) {
  return this.u62(encoder, value instanceof JsonArray ? value : THROW_CCE());
};
protoOf(JsonArraySerializer).zn = function (decoder) {
  verify_0(decoder);
  return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).zn(decoder));
};
var JsonArraySerializer_instance;
function JsonArraySerializer_getInstance() {
  if (JsonArraySerializer_instance == null)
    new JsonArraySerializer();
  return JsonArraySerializer_instance;
}
function JsonObjectDescriptor() {
  JsonObjectDescriptor_instance = this;
  this.v62_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).xn();
  this.w62_1 = 'kotlinx.serialization.json.JsonObject';
}
protoOf(JsonObjectDescriptor).yo = function () {
  return this.w62_1;
};
protoOf(JsonObjectDescriptor).sp = function (index) {
  return this.v62_1.sp(index);
};
protoOf(JsonObjectDescriptor).tp = function (name) {
  return this.v62_1.tp(name);
};
protoOf(JsonObjectDescriptor).up = function (index) {
  return this.v62_1.up(index);
};
protoOf(JsonObjectDescriptor).vp = function (index) {
  return this.v62_1.vp(index);
};
protoOf(JsonObjectDescriptor).wp = function (index) {
  return this.v62_1.wp(index);
};
protoOf(JsonObjectDescriptor).op = function () {
  return this.v62_1.op();
};
protoOf(JsonObjectDescriptor).kp = function () {
  return this.v62_1.kp();
};
protoOf(JsonObjectDescriptor).pp = function () {
  return this.v62_1.pp();
};
protoOf(JsonObjectDescriptor).qp = function () {
  return this.v62_1.qp();
};
protoOf(JsonObjectDescriptor).rp = function () {
  return this.v62_1.rp();
};
var JsonObjectDescriptor_instance;
function JsonObjectDescriptor_getInstance() {
  if (JsonObjectDescriptor_instance == null)
    new JsonObjectDescriptor();
  return JsonObjectDescriptor_instance;
}
function JsonObjectSerializer() {
  JsonObjectSerializer_instance = this;
  this.m62_1 = JsonObjectDescriptor_getInstance();
}
protoOf(JsonObjectSerializer).xn = function () {
  return this.m62_1;
};
protoOf(JsonObjectSerializer).x62 = function (encoder, value) {
  verify(encoder);
  MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).yn(encoder, value);
};
protoOf(JsonObjectSerializer).yn = function (encoder, value) {
  return this.x62(encoder, value instanceof JsonObject ? value : THROW_CCE());
};
protoOf(JsonObjectSerializer).zn = function (decoder) {
  verify_0(decoder);
  return new JsonObject(MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).zn(decoder));
};
var JsonObjectSerializer_instance;
function JsonObjectSerializer_getInstance() {
  if (JsonObjectSerializer_instance == null)
    new JsonObjectSerializer();
  return JsonObjectSerializer_instance;
}
function defer(deferred) {
  return new defer$1(deferred);
}
function JsonLiteralSerializer() {
  JsonLiteralSerializer_instance = this;
  this.l62_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
}
protoOf(JsonLiteralSerializer).xn = function () {
  return this.l62_1;
};
protoOf(JsonLiteralSerializer).y62 = function (encoder, value) {
  verify(encoder);
  if (value.b62_1) {
    return encoder.os(value.d62_1);
  }
  if (!(value.c62_1 == null)) {
    return encoder.qs(value.c62_1).os(value.d62_1);
  }
  var tmp0_safe_receiver = toLongOrNull(value.d62_1);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return encoder.ks(tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = toULongOrNull(value.d62_1);
  var tmp = tmp1_safe_receiver;
  if ((tmp == null ? null : new ULong(tmp)) == null)
    null;
  else {
    var tmp_0 = tmp1_safe_receiver;
    // Inline function 'kotlin.let' call
    var it = (tmp_0 == null ? null : new ULong(tmp_0)).fn_1;
    var tmp_1 = encoder.qs(serializer_0(Companion_getInstance()).xn());
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$1 = _ULong___get_data__impl__fggpzb(it);
    tmp_1.ks(tmp$ret$1);
    return Unit_instance;
  }
  var tmp2_safe_receiver = toDoubleOrNull(value.d62_1);
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return encoder.ms(tmp2_safe_receiver);
  }
  var tmp3_safe_receiver = toBooleanStrictOrNull(value.d62_1);
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return encoder.gs(tmp3_safe_receiver);
  }
  encoder.os(value.d62_1);
};
protoOf(JsonLiteralSerializer).yn = function (encoder, value) {
  return this.y62(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
};
protoOf(JsonLiteralSerializer).zn = function (decoder) {
  var result = asJsonDecoder(decoder).t61();
  if (!(result instanceof JsonLiteral))
    throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + toString(getKClassFromExpression(result)), toString(result));
  return result;
};
var JsonLiteralSerializer_instance;
function JsonLiteralSerializer_getInstance() {
  if (JsonLiteralSerializer_instance == null)
    new JsonLiteralSerializer();
  return JsonLiteralSerializer_instance;
}
function verify(encoder) {
  asJsonEncoder(encoder);
}
function asJsonDecoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function verify_0(decoder) {
  asJsonDecoder(decoder);
}
function asJsonEncoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function _get_original__l7ku1m($this) {
  var tmp0 = $this.z62_1;
  // Inline function 'kotlin.getValue' call
  original$factory();
  return tmp0.t();
}
function defer$1($deferred) {
  this.z62_1 = lazy($deferred);
}
protoOf(defer$1).yo = function () {
  return _get_original__l7ku1m(this).yo();
};
protoOf(defer$1).op = function () {
  return _get_original__l7ku1m(this).op();
};
protoOf(defer$1).qp = function () {
  return _get_original__l7ku1m(this).qp();
};
protoOf(defer$1).sp = function (index) {
  return _get_original__l7ku1m(this).sp(index);
};
protoOf(defer$1).tp = function (name) {
  return _get_original__l7ku1m(this).tp(name);
};
protoOf(defer$1).up = function (index) {
  return _get_original__l7ku1m(this).up(index);
};
protoOf(defer$1).vp = function (index) {
  return _get_original__l7ku1m(this).vp(index);
};
protoOf(defer$1).wp = function (index) {
  return _get_original__l7ku1m(this).wp(index);
};
function original$factory() {
  return getPropertyCallableRef('original', 1, KProperty1, function (receiver) {
    return _get_original__l7ku1m(receiver);
  }, null);
}
function JsonEncoder() {
}
function Composer(writer) {
  this.a63_1 = writer;
  this.b63_1 = true;
}
protoOf(Composer).c63 = function () {
  this.b63_1 = true;
};
protoOf(Composer).d63 = function () {
  return Unit_instance;
};
protoOf(Composer).e63 = function () {
  this.b63_1 = false;
};
protoOf(Composer).f63 = function () {
  this.b63_1 = false;
};
protoOf(Composer).g63 = function () {
  return Unit_instance;
};
protoOf(Composer).h63 = function (v) {
  return this.a63_1.i63(v);
};
protoOf(Composer).j63 = function (v) {
  return this.a63_1.k63(v);
};
protoOf(Composer).l63 = function (v) {
  return this.a63_1.k63(v.toString());
};
protoOf(Composer).m63 = function (v) {
  return this.a63_1.k63(v.toString());
};
protoOf(Composer).n63 = function (v) {
  return this.a63_1.o63(toLong(v));
};
protoOf(Composer).p63 = function (v) {
  return this.a63_1.o63(toLong(v));
};
protoOf(Composer).q63 = function (v) {
  return this.a63_1.o63(toLong(v));
};
protoOf(Composer).r63 = function (v) {
  return this.a63_1.o63(v);
};
protoOf(Composer).s63 = function (v) {
  return this.a63_1.k63(v.toString());
};
protoOf(Composer).t63 = function (value) {
  return this.a63_1.u63(value);
};
function Composer_0(sb, json) {
  return json.p5z_1.f61_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
}
function ComposerForUnsignedNumbers(writer, forceQuoting) {
  Composer.call(this, writer);
  this.x63_1 = forceQuoting;
}
protoOf(ComposerForUnsignedNumbers).q63 = function (v) {
  if (this.x63_1) {
    // Inline function 'kotlin.toUInt' call
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
    this.t63(UInt__toString_impl_dbgl21(tmp$ret$0));
  } else {
    // Inline function 'kotlin.toUInt' call
    var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
    this.j63(UInt__toString_impl_dbgl21(tmp$ret$1));
  }
};
protoOf(ComposerForUnsignedNumbers).r63 = function (v) {
  if (this.x63_1) {
    // Inline function 'kotlin.toULong' call
    var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
    this.t63(ULong__toString_impl_f9au7k(tmp$ret$0));
  } else {
    // Inline function 'kotlin.toULong' call
    var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
    this.j63(ULong__toString_impl_f9au7k(tmp$ret$1));
  }
};
protoOf(ComposerForUnsignedNumbers).n63 = function (v) {
  if (this.x63_1) {
    // Inline function 'kotlin.toUByte' call
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
    this.t63(UByte__toString_impl_v72jg(tmp$ret$0));
  } else {
    // Inline function 'kotlin.toUByte' call
    var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
    this.j63(UByte__toString_impl_v72jg(tmp$ret$1));
  }
};
protoOf(ComposerForUnsignedNumbers).p63 = function (v) {
  if (this.x63_1) {
    // Inline function 'kotlin.toUShort' call
    var tmp$ret$0 = _UShort___init__impl__jigrne(v);
    this.t63(UShort__toString_impl_edaoee(tmp$ret$0));
  } else {
    // Inline function 'kotlin.toUShort' call
    var tmp$ret$1 = _UShort___init__impl__jigrne(v);
    this.j63(UShort__toString_impl_edaoee(tmp$ret$1));
  }
};
function ComposerForUnquotedLiterals(writer, forceQuoting) {
  Composer.call(this, writer);
  this.a64_1 = forceQuoting;
}
protoOf(ComposerForUnquotedLiterals).t63 = function (value) {
  if (this.a64_1) {
    protoOf(Composer).t63.call(this, value);
  } else {
    protoOf(Composer).j63.call(this, value);
  }
};
function ComposerWithPrettyPrint(writer, json) {
  Composer.call(this, writer);
  this.d64_1 = json;
  this.e64_1 = 0;
}
protoOf(ComposerWithPrettyPrint).c63 = function () {
  this.b63_1 = true;
  this.e64_1 = this.e64_1 + 1 | 0;
};
protoOf(ComposerWithPrettyPrint).d63 = function () {
  this.e64_1 = this.e64_1 - 1 | 0;
};
protoOf(ComposerWithPrettyPrint).e63 = function () {
  this.b63_1 = false;
  this.j63('\n');
  // Inline function 'kotlin.repeat' call
  var times = this.e64_1;
  var inductionVariable = 0;
  if (inductionVariable < times)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.j63(this.d64_1.p5z_1.h61_1);
    }
     while (inductionVariable < times);
};
protoOf(ComposerWithPrettyPrint).f63 = function () {
  if (this.b63_1)
    this.b63_1 = false;
  else {
    this.e63();
  }
};
protoOf(ComposerWithPrettyPrint).g63 = function () {
  this.h63(_Char___init__impl__6a9atx(32));
};
function readIfAbsent($this, descriptor, index) {
  $this.g64_1 = (!descriptor.wp(index) && descriptor.vp(index).kp());
  return $this.g64_1;
}
function JsonElementMarker$readIfAbsent$ref($boundThis) {
  var l = function (p0, p1) {
    return readIfAbsent($boundThis, p0, p1);
  };
  l.callableName = 'readIfAbsent';
  return l;
}
function JsonElementMarker(descriptor) {
  var tmp = this;
  tmp.f64_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
  this.g64_1 = false;
}
protoOf(JsonElementMarker).h64 = function (index) {
  this.f64_1.qx(index);
};
protoOf(JsonElementMarker).i64 = function () {
  return this.f64_1.rx();
};
function JsonDecodingException(message) {
  JsonException.call(this, message);
  captureStack(this, JsonDecodingException);
}
function JsonDecodingException_0(offset, message, input) {
  return JsonDecodingException_1(offset, message + '\nJSON input: ' + toString(minify(input, offset)));
}
function invalidTrailingComma(_this__u8e3s4, entity) {
  entity = entity === VOID ? 'object' : entity;
  _this__u8e3s4.j64('Trailing comma before the end of JSON ' + entity, _this__u8e3s4.d60_1 - 1 | 0, "Trailing commas are non-complaint JSON and not allowed by default. Use 'allowTrailingComma = true' in 'Json {}' builder to support them.");
}
function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
  _this__u8e3s4.k64('Unexpected special floating-point value ' + toString(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
}
function JsonEncodingException(message) {
  JsonException.call(this, message);
  captureStack(this, JsonEncodingException);
}
function InvalidKeyKindException(keyDescriptor) {
  return new JsonEncodingException("Value of type '" + keyDescriptor.yo() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.op().toString() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
}
function InvalidFloatingPointDecoded(value, key, output) {
  return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
}
function JsonDecodingException_1(offset, message) {
  return new JsonDecodingException(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
}
function minify(_this__u8e3s4, offset) {
  offset = offset === VOID ? -1 : offset;
  if (charSequenceLength(_this__u8e3s4) < 200)
    return _this__u8e3s4;
  if (offset === -1) {
    var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
    if (start <= 0)
      return _this__u8e3s4;
    // Inline function 'kotlin.text.substring' call
    var endIndex = charSequenceLength(_this__u8e3s4);
    return '.....' + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
  }
  var start_0 = offset - 30 | 0;
  var end = offset + 30 | 0;
  var prefix = start_0 <= 0 ? '' : '.....';
  var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
  var tmp4 = coerceAtLeast(start_0, 0);
  // Inline function 'kotlin.text.substring' call
  var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
  return prefix + toString(charSequenceSubSequence(_this__u8e3s4, tmp4, endIndex_0)) + suffix;
}
function JsonException(message) {
  SerializationException_init_$Init$(message, this);
  captureStack(this, JsonException);
}
function unexpectedFpErrorMessage(value, key, output) {
  return 'Unexpected special floating-point value ' + toString(value) + ' with key ' + key + '. By default, ' + "non-finite floating point values are prohibited because they do not conform JSON specification. It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output)));
}
function InvalidFloatingPointEncoded(value, output) {
  return new JsonEncodingException('Unexpected special floating-point value ' + toString(value) + '. By default, ' + "non-finite floating point values are prohibited because they do not conform JSON specification. It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output))));
}
function get_JsonDeserializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonDeserializationNamesKey;
}
var JsonDeserializationNamesKey;
function get_JsonSerializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonSerializationNamesKey;
}
var JsonSerializationNamesKey;
function ignoreUnknownKeys(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp;
  if (json.p5z_1.c61_1) {
    tmp = true;
  } else {
    var tmp0 = _this__u8e3s4.rp();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.p();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (element instanceof JsonIgnoreUnknownKeys) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp = tmp$ret$0;
  }
  return tmp;
}
function getJsonNameIndex(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  if (decodeCaseInsensitive(json, _this__u8e3s4)) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = name.toLowerCase();
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, tmp$ret$1);
  }
  var strategy = namingStrategy(_this__u8e3s4, json);
  if (!(strategy == null))
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
  var index = _this__u8e3s4.tp(name);
  if (!(index === -3))
    return index;
  if (!json.p5z_1.m61_1)
    return index;
  return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
}
function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
  suffix = suffix === VOID ? '' : suffix;
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var index = getJsonNameIndex(_this__u8e3s4, json, name);
  if (index === -3)
    throw SerializationException_init_$Create$(_this__u8e3s4.yo() + " does not contain element with name '" + name + "'" + suffix);
  return index;
}
function getJsonElementName(_this__u8e3s4, json, index) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var strategy = namingStrategy(_this__u8e3s4, json);
  return strategy == null ? _this__u8e3s4.sp(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
}
function namingStrategy(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return equals(_this__u8e3s4.op(), CLASS_getInstance()) ? json.p5z_1.n61_1 : null;
}
function deserializationNamesMap(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(_this__u8e3s4);
  var tmp_0 = get_JsonDeserializationNamesKey();
  return tmp.m64(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
}
function decodeCaseInsensitive(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return _this__u8e3s4.p5z_1.o61_1 && equals(descriptor.op(), ENUM_getInstance());
}
function getJsonNameIndexSlowPath(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp0_elvis_lhs = deserializationNamesMap(json, _this__u8e3s4).a2(name);
  return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
}
function serializationNamesIndices(_this__u8e3s4, json, strategy) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(json);
  var tmp_0 = get_JsonSerializationNamesKey();
  return tmp.m64(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
}
function buildDeserializationNamesMap(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var builder = LinkedHashMap_init_$Create$();
  var useLowercaseEnums = decodeCaseInsensitive(json, _this__u8e3s4);
  var strategyForClasses = namingStrategy(_this__u8e3s4, json);
  var inductionVariable = 0;
  var last = _this__u8e3s4.qp();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.filterIsInstance' call
      var tmp0 = _this__u8e3s4.up(i);
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (element instanceof JsonNames) {
          destination.e(element);
        }
      }
      var tmp0_safe_receiver = singleOrNull(destination);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n64_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp1_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp1_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp;
          if (useLowercaseEnums) {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp = element_0.toLowerCase();
          } else {
            tmp = element_0;
          }
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, tmp, i);
        }
      }
      var tmp_0;
      if (useLowercaseEnums) {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = _this__u8e3s4.sp(i).toLowerCase();
      } else if (!(strategyForClasses == null)) {
        tmp_0 = strategyForClasses.o64(_this__u8e3s4, i, _this__u8e3s4.sp(i));
      } else {
        tmp_0 = null;
      }
      var nameToPut = tmp_0;
      if (nameToPut == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, nameToPut, i);
      }
    }
     while (inductionVariable < last);
  // Inline function 'kotlin.collections.ifEmpty' call
  var tmp_1;
  if (builder.p()) {
    tmp_1 = emptyMap();
  } else {
    tmp_1 = builder;
  }
  return tmp_1;
}
function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
  var entity = equals($this_buildDeserializationNamesMap.op(), ENUM_getInstance()) ? 'enum value' : 'property';
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  if ((isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).y1(name)) {
    throw new JsonException("The suggested name '" + name + "' for " + entity + ' ' + $this_buildDeserializationNamesMap.sp(index) + ' is already one of the names for ' + entity + ' ' + ($this_buildDeserializationNamesMap.sp(getValue(_this__u8e3s4, name)) + ' in ' + toString($this_buildDeserializationNamesMap)));
  }
  // Inline function 'kotlin.collections.set' call
  _this__u8e3s4.h2(name, index);
}
function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
  return function () {
    return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
  };
}
function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
  return function () {
    var tmp = 0;
    var tmp_0 = $this_serializationNamesIndices.qp();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var baseName = $this_serializationNamesIndices.sp(tmp_2);
      tmp_1[tmp_2] = $strategy.o64($this_serializationNamesIndices, tmp_2, baseName);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
var properties_initialized_JsonNamesMap_kt_ljpf42;
function _init_properties_JsonNamesMap_kt__cbbp0k() {
  if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
    properties_initialized_JsonNamesMap_kt_ljpf42 = true;
    JsonDeserializationNamesKey = new Key();
    JsonSerializationNamesKey = new Key();
  }
}
function Tombstone() {
}
var Tombstone_instance;
function Tombstone_getInstance() {
  return Tombstone_instance;
}
function resize($this) {
  var newSize = imul($this.r64_1, 2);
  $this.p64_1 = copyOf($this.p64_1, newSize);
  $this.q64_1 = copyOf_0($this.q64_1, newSize);
}
function JsonPath() {
  var tmp = this;
  // Inline function 'kotlin.arrayOfNulls' call
  tmp.p64_1 = Array(8);
  var tmp_0 = this;
  var tmp_1 = 0;
  var tmp_2 = new Int32Array(8);
  while (tmp_1 < 8) {
    tmp_2[tmp_1] = -1;
    tmp_1 = tmp_1 + 1 | 0;
  }
  tmp_0.q64_1 = tmp_2;
  this.r64_1 = -1;
}
protoOf(JsonPath).s64 = function (sd) {
  this.r64_1 = this.r64_1 + 1 | 0;
  var depth = this.r64_1;
  if (depth === this.p64_1.length) {
    resize(this);
  }
  this.p64_1[depth] = sd;
};
protoOf(JsonPath).t64 = function (index) {
  this.q64_1[this.r64_1] = index;
};
protoOf(JsonPath).u64 = function (key) {
  var tmp;
  if (!(this.q64_1[this.r64_1] === -2)) {
    this.r64_1 = this.r64_1 + 1 | 0;
    tmp = this.r64_1 === this.p64_1.length;
  } else {
    tmp = false;
  }
  if (tmp) {
    resize(this);
  }
  this.p64_1[this.r64_1] = key;
  this.q64_1[this.r64_1] = -2;
};
protoOf(JsonPath).v64 = function () {
  if (this.q64_1[this.r64_1] === -2) {
    this.p64_1[this.r64_1] = Tombstone_instance;
  }
};
protoOf(JsonPath).w64 = function () {
  var depth = this.r64_1;
  if (this.q64_1[depth] === -2) {
    this.q64_1[depth] = -1;
    this.r64_1 = this.r64_1 - 1 | 0;
  }
  if (!(this.r64_1 === -1)) {
    this.r64_1 = this.r64_1 - 1 | 0;
  }
};
protoOf(JsonPath).x64 = function () {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  this_0.b8('$');
  // Inline function 'kotlin.repeat' call
  var times = this.r64_1 + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < times)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var element = this.p64_1[index];
      if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
        if (equals(element.op(), LIST_getInstance())) {
          if (!(this.q64_1[index] === -1)) {
            this_0.b8('[');
            this_0.ic(this.q64_1[index]);
            this_0.b8(']');
          }
        } else {
          var idx = this.q64_1[index];
          if (idx >= 0) {
            this_0.b8('.');
            this_0.b8(element.sp(idx));
          }
        }
      } else {
        if (!(element === Tombstone_instance)) {
          this_0.b8('[');
          this_0.b8("'");
          this_0.a8(element);
          this_0.b8("'");
          this_0.b8(']');
        }
      }
    }
     while (inductionVariable < times);
  return this_0.toString();
};
protoOf(JsonPath).toString = function () {
  return this.x64();
};
function checkKind($this, descriptor, actualClass) {
  var kind = descriptor.op();
  var tmp;
  if (kind instanceof PolymorphicKind) {
    tmp = true;
  } else {
    tmp = equals(kind, CONTEXTUAL_getInstance());
  }
  if (tmp) {
    throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.pa() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind.toString() + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
  }
  if ($this.z64_1)
    return Unit_instance;
  if (!$this.a65_1)
    return Unit_instance;
  var tmp_0;
  var tmp_1;
  if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) {
    tmp_1 = true;
  } else {
    tmp_1 = kind instanceof PrimitiveKind;
  }
  if (tmp_1) {
    tmp_0 = true;
  } else {
    tmp_0 = kind instanceof ENUM;
  }
  if (tmp_0) {
    throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.pa() + ' of kind ' + kind.toString() + ' cannot be serialized polymorphically with class discriminator.');
  }
}
function checkDiscriminatorCollisions($this, descriptor, actualClass) {
  var inductionVariable = 0;
  var last = descriptor.qp();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var name = descriptor.sp(i);
      if (name === $this.y64_1) {
        throw IllegalArgumentException_init_$Create$('Polymorphic serializer for ' + toString(actualClass) + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, rename property with @SerialName annotation or fall back to array polymorphism');
      }
    }
     while (inductionVariable < last);
}
function JsonSerializersModuleValidator(configuration) {
  this.y64_1 = configuration.k61_1;
  this.z64_1 = configuration.j61_1;
  this.a65_1 = !configuration.r61_1.equals(ClassDiscriminatorMode_NONE_getInstance());
}
protoOf(JsonSerializersModuleValidator).c18 = function (kClass, provider) {
};
protoOf(JsonSerializersModuleValidator).f18 = function (baseClass, actualClass, actualSerializer) {
  var descriptor = actualSerializer.xn();
  checkKind(this, descriptor, actualClass);
  if (!this.z64_1 && this.a65_1) {
    checkDiscriminatorCollisions(this, descriptor, actualClass);
  }
};
protoOf(JsonSerializersModuleValidator).g18 = function (baseClass, defaultSerializerProvider) {
};
protoOf(JsonSerializersModuleValidator).h18 = function (baseClass, defaultDeserializerProvider) {
};
function encodeByWriter(json, writer, serializer, value) {
  var tmp = WriteMode_OBJ_getInstance();
  // Inline function 'kotlin.arrayOfNulls' call
  var size = get_entries().m();
  var tmp$ret$0 = Array(size);
  var encoder = StreamingJsonEncoder_init_$Create$(writer, json, tmp, tmp$ret$0);
  encoder.ct(serializer, value);
}
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.k65_1.o65(6);
  if ($this.k65_1.p65() === 4) {
    $this.k65_1.k64('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap_init_$Create$();
  $l$loop: while ($this.k65_1.q65()) {
    var key = $this.l65_1 ? $this.k65_1.s65() : $this.k65_1.r65();
    $this.k65_1.o65(5);
    var element = $this.t65();
    // Inline function 'kotlin.collections.set' call
    result.h2(key, element);
    lastToken = $this.k65_1.u65();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.k65_1.k64('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.k65_1.o65(7);
  } else if (lastToken === 4) {
    if (!$this.m65_1) {
      invalidTrailingComma($this.k65_1);
    }
    $this.k65_1.o65(7);
  }
  return new JsonObject(result);
}
function readObject_0($this, _this__u8e3s4, $completion) {
  var tmp = new $readObjectCOROUTINE$0($this, _this__u8e3s4, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function readArray($this) {
  var lastToken = $this.k65_1.u65();
  if ($this.k65_1.p65() === 4) {
    $this.k65_1.k64('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList_init_$Create$();
  while ($this.k65_1.q65()) {
    var element = $this.t65();
    result.e(element);
    lastToken = $this.k65_1.u65();
    if (!(lastToken === 4)) {
      var tmp0 = $this.k65_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.d60_1;
      if (!condition) {
        var tmp$ret$1 = 'Expected end of the array or comma';
        tmp0.k64(tmp$ret$1, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.k65_1.o65(9);
  } else if (lastToken === 4) {
    if (!$this.m65_1) {
      invalidTrailingComma($this.k65_1, 'array');
    }
    $this.k65_1.o65(9);
  }
  return new JsonArray(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.l65_1 || !isString) {
    tmp = $this.k65_1.s65();
  } else {
    tmp = $this.k65_1.r65();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new JsonLiteral(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this, null)), Unit_instance);
}
function JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation) {
  this.s66_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(JsonTreeReader$readDeepRecursive$slambda).x66 = function ($this$DeepRecursiveFunction, it, $completion) {
  var tmp = this.y66($this$DeepRecursiveFunction, it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(JsonTreeReader$readDeepRecursive$slambda).i9 = function (p1, p2, $completion) {
  var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
  return this.x66(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
};
protoOf(JsonTreeReader$readDeepRecursive$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.v66_1 = this.s66_1.k65_1.p65();
          if (this.v66_1 === 1) {
            this.w66_1 = readValue(this.s66_1, true);
            this.n8_1 = 2;
            continue $sm;
          } else {
            if (this.v66_1 === 0) {
              this.w66_1 = readValue(this.s66_1, false);
              this.n8_1 = 2;
              continue $sm;
            } else {
              if (this.v66_1 === 6) {
                this.n8_1 = 1;
                suspendResult = readObject_0(this.s66_1, this.t66_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (this.v66_1 === 8) {
                  this.w66_1 = readArray(this.s66_1);
                  this.n8_1 = 2;
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  this.s66_1.k65_1.k64("Can't begin reading element, unexpected token");
                }
              }
            }
          }

          break;
        case 1:
          this.w66_1 = suspendResult;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return this.w66_1;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(JsonTreeReader$readDeepRecursive$slambda).y66 = function ($this$DeepRecursiveFunction, it, completion) {
  var i = new JsonTreeReader$readDeepRecursive$slambda(this.s66_1, completion);
  i.t66_1 = $this$DeepRecursiveFunction;
  i.u66_1 = it;
  return i;
};
function JsonTreeReader$readDeepRecursive$slambda_0(this$0, resultContinuation) {
  var i = new JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation);
  var l = function ($this$DeepRecursiveFunction, it, $completion) {
    return i.x66($this$DeepRecursiveFunction, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function $readObjectCOROUTINE$0(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.d66_1 = _this__u8e3s4;
  this.e66_1 = _this__u8e3s4_0;
}
protoOf($readObjectCOROUTINE$0).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 5;
          var tmp_0 = this;
          tmp_0.f66_1 = this.d66_1;
          this.g66_1 = this.f66_1;
          this.h66_1 = this.g66_1.k65_1.o65(6);
          if (this.g66_1.k65_1.p65() === 4) {
            this.g66_1.k65_1.k64('Unexpected leading comma');
          }

          var tmp_1 = this;
          tmp_1.i66_1 = LinkedHashMap_init_$Create$();
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!this.g66_1.k65_1.q65()) {
            this.n8_1 = 4;
            continue $sm;
          }

          this.j66_1 = this.g66_1.l65_1 ? this.g66_1.k65_1.s65() : this.g66_1.k65_1.r65();
          this.g66_1.k65_1.o65(5);
          this.n8_1 = 2;
          suspendResult = this.e66_1.jl(Unit_instance, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          var element = suspendResult;
          var tmp0 = this.i66_1;
          var key = this.j66_1;
          tmp0.h2(key, element);
          this.h66_1 = this.g66_1.k65_1.u65();
          var tmp0_subject = this.h66_1;
          if (tmp0_subject === 4) {
            this.n8_1 = 3;
            continue $sm;
          } else {
            if (tmp0_subject === 7) {
              this.n8_1 = 4;
              continue $sm;
            } else {
              this.g66_1.k65_1.k64('Expected end of the object or comma');
            }
          }

          break;
        case 3:
          this.n8_1 = 1;
          continue $sm;
        case 4:
          if (this.h66_1 === 6) {
            this.g66_1.k65_1.o65(7);
          } else if (this.h66_1 === 4) {
            if (!this.g66_1.m65_1) {
              invalidTrailingComma(this.g66_1.k65_1);
            }
            this.g66_1.k65_1.o65(7);
          }

          return new JsonObject(this.i66_1);
        case 5:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 5) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function JsonTreeReader(configuration, lexer) {
  this.k65_1 = lexer;
  this.l65_1 = configuration.d61_1;
  this.m65_1 = configuration.p61_1;
  this.n65_1 = 0;
}
protoOf(JsonTreeReader).t65 = function () {
  var token = this.k65_1.p65();
  var tmp;
  if (token === 1) {
    tmp = readValue(this, true);
  } else if (token === 0) {
    tmp = readValue(this, false);
  } else if (token === 6) {
    var tmp_0;
    this.n65_1 = this.n65_1 + 1 | 0;
    if (this.n65_1 === 200) {
      tmp_0 = readDeepRecursive(this);
    } else {
      tmp_0 = readObject(this);
    }
    var result = tmp_0;
    this.n65_1 = this.n65_1 - 1 | 0;
    tmp = result;
  } else if (token === 8) {
    tmp = readArray(this);
  } else {
    this.k65_1.k64('Cannot read Json element because of unexpected ' + tokenDescription(token));
  }
  return tmp;
};
function classDiscriminator(_this__u8e3s4, json) {
  var _iterator__ex2g4s = _this__u8e3s4.rp().j();
  while (_iterator__ex2g4s.k()) {
    var annotation = _iterator__ex2g4s.l();
    if (annotation instanceof JsonClassDiscriminator)
      return annotation.z66_1;
  }
  return json.p5z_1.k61_1;
}
function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
  if (!(serializer instanceof SealedClassSerializer))
    return Unit_instance;
  if (jsonCachedSerialNames(actualSerializer.xn()).u1(classDiscriminator)) {
    var baseName = serializer.xn().yo();
    var actualName = actualSerializer.xn().yo();
    // Inline function 'kotlin.error' call
    var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, rename property with @SerialName annotation or fall back to array polymorphism';
    throw IllegalStateException_init_$Create$(toString(message));
  }
}
function checkKind_0(kind) {
  if (kind instanceof ENUM) {
    // Inline function 'kotlin.error' call
    var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException_init_$Create$(toString(message));
  }
  if (kind instanceof PrimitiveKind) {
    // Inline function 'kotlin.error' call
    var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException_init_$Create$(toString(message_0));
  }
  if (kind instanceof PolymorphicKind) {
    // Inline function 'kotlin.error' call
    var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
    throw IllegalStateException_init_$Create$(toString(message_1));
  }
}
function access$validateIfSealed$tPolymorphicKt(serializer, actualSerializer, classDiscriminator) {
  return validateIfSealed(serializer, actualSerializer, classDiscriminator);
}
function Key() {
}
function DescriptorSchemaCache() {
  this.l64_1 = createMapForCache(16);
}
protoOf(DescriptorSchemaCache).a67 = function (descriptor, key, value) {
  // Inline function 'kotlin.collections.getOrPut' call
  var this_0 = this.l64_1;
  var value_0 = this_0.a2(descriptor);
  var tmp;
  if (value_0 == null) {
    var answer = createMapForCache(2);
    this_0.h2(descriptor, answer);
    tmp = answer;
  } else {
    tmp = value_0;
  }
  var tmp2 = tmp;
  var tmp3 = key instanceof Key ? key : THROW_CCE();
  // Inline function 'kotlin.collections.set' call
  var value_1 = !(value == null) ? value : THROW_CCE();
  tmp2.h2(tmp3, value_1);
};
protoOf(DescriptorSchemaCache).m64 = function (descriptor, key, defaultValue) {
  var tmp0_safe_receiver = this.b67(descriptor, key);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp0_safe_receiver;
  }
  var value = defaultValue();
  this.a67(descriptor, key, value);
  return value;
};
protoOf(DescriptorSchemaCache).b67 = function (descriptor, key) {
  var tmp0_safe_receiver = this.l64_1.a2(descriptor);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    tmp = tmp0_safe_receiver.a2(key instanceof Key ? key : THROW_CCE());
  }
  var tmp_0 = tmp;
  return !(tmp_0 == null) ? tmp_0 : null;
};
function DiscriminatorHolder(discriminatorToSkip) {
  this.c67_1 = discriminatorToSkip;
}
function trySkip($this, _this__u8e3s4, unknownKey) {
  if (_this__u8e3s4 == null)
    return false;
  if (_this__u8e3s4.c67_1 === unknownKey) {
    _this__u8e3s4.c67_1 = null;
    return true;
  }
  return false;
}
function skipLeftoverElements($this, descriptor) {
  while (!($this.bs(descriptor) === -1)) {
  }
}
function checkLeadingComma($this) {
  if ($this.x5z_1.p65() === 4) {
    $this.x5z_1.k64('Unexpected leading comma');
  }
}
function decodeMapIndex($this) {
  var hasComma = false;
  var decodingKey = !(($this.z5z_1 % 2 | 0) === 0);
  if (decodingKey) {
    if (!($this.z5z_1 === -1)) {
      hasComma = $this.x5z_1.e67();
    }
  } else {
    $this.x5z_1.d67(_Char___init__impl__6a9atx(58));
  }
  var tmp;
  if ($this.x5z_1.q65()) {
    if (decodingKey) {
      if ($this.z5z_1 === -1) {
        var tmp0 = $this.x5z_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = !hasComma;
        var position = tmp0.d60_1;
        if (!condition) {
          var tmp$ret$0 = 'Unexpected leading comma';
          tmp0.k64(tmp$ret$0, position);
        }
      } else {
        var tmp3 = $this.x5z_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition_0 = hasComma;
        var position_0 = tmp3.d60_1;
        if (!condition_0) {
          var tmp$ret$2 = 'Expected comma after the key-value pair';
          tmp3.k64(tmp$ret$2, position_0);
        }
      }
    }
    $this.z5z_1 = $this.z5z_1 + 1 | 0;
    tmp = $this.z5z_1;
  } else {
    if (hasComma && !$this.v5z_1.p5z_1.p61_1) {
      invalidTrailingComma($this.x5z_1);
    }
    tmp = -1;
  }
  return tmp;
}
function coerceInputValue($this, descriptor, index) {
  var tmp0 = $this.v5z_1;
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var isOptional = descriptor.wp(index);
    var elementDescriptor = descriptor.vp(index);
    var tmp;
    if (isOptional && !elementDescriptor.kp()) {
      tmp = $this.x5z_1.f67(true);
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$1 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.op(), ENUM_getInstance())) {
      var tmp_0;
      if (elementDescriptor.kp()) {
        tmp_0 = $this.x5z_1.f67(false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$1 = false;
        break $l$block_2;
      }
      var tmp0_elvis_lhs = $this.x5z_1.g67($this.b60_1.d61_1);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$1 = false;
        break $l$block_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_1;
      var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
      var coerceToNull = !tmp0.p5z_1.g61_1 && elementDescriptor.kp();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        $this.x5z_1.r65();
        tmp$ret$1 = true;
        break $l$block_2;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
}
function decodeObjectIndex($this, descriptor) {
  var hasComma = $this.x5z_1.e67();
  while ($this.x5z_1.q65()) {
    hasComma = false;
    var key = decodeStringKey($this);
    $this.x5z_1.d67(_Char___init__impl__6a9atx(58));
    var index = getJsonNameIndex(descriptor, $this.v5z_1, key);
    var tmp;
    if (!(index === -3)) {
      var tmp_0;
      if ($this.b60_1.i61_1 && coerceInputValue($this, descriptor, index)) {
        hasComma = $this.x5z_1.e67();
        tmp_0 = false;
      } else {
        var tmp0_safe_receiver = $this.c60_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.h64(index);
        }
        return index;
      }
      tmp = tmp_0;
    } else {
      tmp = true;
    }
    var isUnknown = tmp;
    if (isUnknown) {
      hasComma = handleUnknown($this, descriptor, key);
    }
  }
  if (hasComma && !$this.v5z_1.p5z_1.p61_1) {
    invalidTrailingComma($this.x5z_1);
  }
  var tmp1_safe_receiver = $this.c60_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.i64();
  return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
}
function handleUnknown($this, descriptor, key) {
  if (ignoreUnknownKeys(descriptor, $this.v5z_1) || trySkip($this, $this.a60_1, key)) {
    $this.x5z_1.i67($this.b60_1.d61_1);
  } else {
    $this.x5z_1.e60_1.w64();
    $this.x5z_1.h67(key);
  }
  return $this.x5z_1.e67();
}
function decodeListIndex($this) {
  var hasComma = $this.x5z_1.e67();
  var tmp;
  if ($this.x5z_1.q65()) {
    if (!($this.z5z_1 === -1) && !hasComma) {
      $this.x5z_1.k64('Expected end of the array or comma');
    }
    $this.z5z_1 = $this.z5z_1 + 1 | 0;
    tmp = $this.z5z_1;
  } else {
    if (hasComma && !$this.v5z_1.p5z_1.p61_1) {
      invalidTrailingComma($this.x5z_1, 'array');
    }
    tmp = -1;
  }
  return tmp;
}
function decodeStringKey($this) {
  var tmp;
  if ($this.b60_1.d61_1) {
    tmp = $this.x5z_1.k67();
  } else {
    tmp = $this.x5z_1.j67();
  }
  return tmp;
}
function StreamingJsonDecoder(json, mode, lexer, descriptor, discriminatorHolder) {
  AbstractDecoder.call(this);
  this.v5z_1 = json;
  this.w5z_1 = mode;
  this.x5z_1 = lexer;
  this.y5z_1 = this.v5z_1.zr();
  this.z5z_1 = -1;
  this.a60_1 = discriminatorHolder;
  this.b60_1 = this.v5z_1.p5z_1;
  this.c60_1 = this.b60_1.g61_1 ? null : new JsonElementMarker(descriptor);
}
protoOf(StreamingJsonDecoder).s61 = function () {
  return this.v5z_1;
};
protoOf(StreamingJsonDecoder).zr = function () {
  return this.y5z_1;
};
protoOf(StreamingJsonDecoder).t61 = function () {
  return (new JsonTreeReader(this.v5z_1.p5z_1, this.x5z_1)).t65();
};
protoOf(StreamingJsonDecoder).jr = function (deserializer) {
  try {
    var tmp;
    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
      tmp = true;
    } else {
      tmp = this.v5z_1.p5z_1.j61_1;
    }
    if (tmp) {
      return deserializer.zn(this);
    }
    var discriminator = classDiscriminator(deserializer.xn(), this.v5z_1);
    var tmp0_elvis_lhs = this.x5z_1.l67(discriminator, this.b60_1.d61_1);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp1 = isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
        var tmp_1;
        if (!(tmp1 instanceof AbstractPolymorphicSerializer)) {
          tmp_1 = true;
        } else {
          tmp_1 = this.s61().p5z_1.j61_1;
        }
        if (tmp_1) {
          tmp$ret$0 = tmp1.zn(this);
          break $l$block;
        }
        var discriminator_0 = classDiscriminator(tmp1.xn(), this.s61());
        var tmp0 = this.t61();
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName = tmp1.xn().yo();
        if (!(tmp0 instanceof JsonObject)) {
          var tmp_2 = getKClass(JsonObject).pa();
          var tmp_3 = getKClassFromExpression(tmp0).pa();
          var tmp$ret$1 = this.x5z_1.e60_1.x64();
          throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString(tmp0));
        }
        var jsonTree = tmp0;
        var tmp0_safe_receiver = jsonTree.h2a(discriminator_0);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
        var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
        var tmp_4;
        try {
          tmp_4 = findPolymorphicSerializer(tmp1, this, type);
        } catch ($p) {
          var tmp_5;
          if ($p instanceof SerializationException) {
            var it = $p;
            throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
          } else {
            throw $p;
          }
        }
        var tmp_6 = tmp_4;
        var actualSerializer = isInterface(tmp_6, DeserializationStrategy) ? tmp_6 : THROW_CCE();
        tmp$ret$0 = readPolymorphicJson(this.s61(), discriminator_0, jsonTree, actualSerializer);
      }
      return tmp$ret$0;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var type_0 = tmp_0;
    var tmp_7;
    try {
      tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
    } catch ($p) {
      var tmp_8;
      if ($p instanceof SerializationException) {
        var it_0 = $p;
        var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
        var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
        this.x5z_1.k64(message, VOID, hint);
      } else {
        throw $p;
      }
      tmp_7 = tmp_8;
    }
    var tmp_9 = tmp_7;
    var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy) ? tmp_9 : THROW_CCE();
    this.a60_1 = new DiscriminatorHolder(discriminator);
    return actualSerializer_0.zn(this);
  } catch ($p) {
    if ($p instanceof MissingFieldException) {
      var e = $p;
      if (contains(ensureNotNull(e.message), 'at path'))
        throw e;
      throw new MissingFieldException(e.ep_1, plus(e.message, ' at path: ') + this.x5z_1.e60_1.x64(), e);
    } else {
      throw $p;
    }
  }
};
protoOf(StreamingJsonDecoder).kr = function (descriptor) {
  var newMode = switchMode(this.v5z_1, descriptor);
  this.x5z_1.e60_1.s64(descriptor);
  this.x5z_1.d67(newMode.o67_1);
  checkLeadingComma(this);
  var tmp;
  switch (newMode.l2_1) {
    case 1:
    case 2:
    case 3:
      tmp = new StreamingJsonDecoder(this.v5z_1, newMode, this.x5z_1, descriptor, this.a60_1);
      break;
    default:
      var tmp_0;
      if (this.w5z_1.equals(newMode) && this.v5z_1.p5z_1.g61_1) {
        tmp_0 = this;
      } else {
        tmp_0 = new StreamingJsonDecoder(this.v5z_1, newMode, this.x5z_1, descriptor, this.a60_1);
      }

      tmp = tmp_0;
      break;
  }
  return tmp;
};
protoOf(StreamingJsonDecoder).lr = function (descriptor) {
  if (descriptor.qp() === 0 && ignoreUnknownKeys(descriptor, this.v5z_1)) {
    skipLeftoverElements(this, descriptor);
  }
  if (this.x5z_1.e67() && !this.v5z_1.p5z_1.p61_1) {
    invalidTrailingComma(this.x5z_1, '');
  }
  this.x5z_1.d67(this.w5z_1.p67_1);
  this.x5z_1.e60_1.w64();
};
protoOf(StreamingJsonDecoder).vq = function () {
  var tmp;
  var tmp0_safe_receiver = this.c60_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g64_1;
  if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
    tmp = !this.x5z_1.q67();
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(StreamingJsonDecoder).wq = function () {
  return null;
};
protoOf(StreamingJsonDecoder).wr = function (descriptor, index, deserializer, previousValue) {
  var isMapKey = this.w5z_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
  if (isMapKey) {
    this.x5z_1.e60_1.v64();
  }
  var value = protoOf(AbstractDecoder).wr.call(this, descriptor, index, deserializer, previousValue);
  if (isMapKey) {
    this.x5z_1.e60_1.u64(value);
  }
  return value;
};
protoOf(StreamingJsonDecoder).bs = function (descriptor) {
  var index;
  switch (this.w5z_1.l2_1) {
    case 0:
      index = decodeObjectIndex(this, descriptor);
      break;
    case 2:
      index = decodeMapIndex(this);
      break;
    default:
      index = decodeListIndex(this);
      break;
  }
  if (!this.w5z_1.equals(WriteMode_MAP_getInstance())) {
    this.x5z_1.e60_1.t64(index);
  }
  return index;
};
protoOf(StreamingJsonDecoder).xq = function () {
  return this.x5z_1.r67();
};
protoOf(StreamingJsonDecoder).yq = function () {
  var value = this.x5z_1.s67();
  if (!value.equals(toLong(value.h3()))) {
    this.x5z_1.k64("Failed to parse byte for input '" + value.toString() + "'");
  }
  return value.h3();
};
protoOf(StreamingJsonDecoder).zq = function () {
  var value = this.x5z_1.s67();
  if (!value.equals(toLong(value.i3()))) {
    this.x5z_1.k64("Failed to parse short for input '" + value.toString() + "'");
  }
  return value.i3();
};
protoOf(StreamingJsonDecoder).ar = function () {
  var value = this.x5z_1.s67();
  if (!value.equals(toLong(value.d1()))) {
    this.x5z_1.k64("Failed to parse int for input '" + value.toString() + "'");
  }
  return value.d1();
};
protoOf(StreamingJsonDecoder).br = function () {
  return this.x5z_1.s67();
};
protoOf(StreamingJsonDecoder).cr = function () {
  var tmp0 = this.x5z_1;
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.s65();
    try {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$4 = toDouble(input);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.k64("Failed to parse type '" + 'float' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  var result = tmp$ret$4;
  var specialFp = this.v5z_1.p5z_1.l61_1;
  if (specialFp || isFinite(result))
    return result;
  throwInvalidFloatingPointDecoded(this.x5z_1, result);
};
protoOf(StreamingJsonDecoder).dr = function () {
  var tmp0 = this.x5z_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.s65();
    try {
      tmp$ret$1 = toDouble(input);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.k64("Failed to parse type '" + 'double' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  var result = tmp$ret$1;
  var specialFp = this.v5z_1.p5z_1.l61_1;
  if (specialFp || isFinite_0(result))
    return result;
  throwInvalidFloatingPointDecoded(this.x5z_1, result);
};
protoOf(StreamingJsonDecoder).er = function () {
  var string = this.x5z_1.s65();
  if (!(string.length === 1)) {
    this.x5z_1.k64("Expected single char, but got '" + string + "'");
  }
  return charSequenceGet(string, 0);
};
protoOf(StreamingJsonDecoder).fr = function () {
  var tmp;
  if (this.b60_1.d61_1) {
    tmp = this.x5z_1.k67();
  } else {
    tmp = this.x5z_1.r65();
  }
  return tmp;
};
protoOf(StreamingJsonDecoder).hr = function (descriptor) {
  return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.x5z_1, this.v5z_1) : protoOf(AbstractDecoder).hr.call(this, descriptor);
};
protoOf(StreamingJsonDecoder).gr = function (enumDescriptor) {
  return getJsonNameIndexOrThrow(enumDescriptor, this.v5z_1, this.fr(), ' at path ' + this.x5z_1.e60_1.x64());
};
function JsonDecoderForUnsignedTypes(lexer, json) {
  AbstractDecoder.call(this);
  this.t67_1 = lexer;
  this.u67_1 = json.zr();
}
protoOf(JsonDecoderForUnsignedTypes).zr = function () {
  return this.u67_1;
};
protoOf(JsonDecoderForUnsignedTypes).bs = function (descriptor) {
  var message = 'unsupported';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(JsonDecoderForUnsignedTypes).ar = function () {
  var tmp0 = this.t67_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.s65();
    try {
      // Inline function 'kotlin.UInt.toInt' call
      var this_0 = toUInt(input);
      tmp$ret$2 = _UInt___get_data__impl__f0vqqw(this_0);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.k64("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$2;
};
protoOf(JsonDecoderForUnsignedTypes).br = function () {
  var tmp0 = this.t67_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.s65();
    try {
      // Inline function 'kotlin.ULong.toLong' call
      var this_0 = toULong(input);
      tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_0);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.k64("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$2;
};
protoOf(JsonDecoderForUnsignedTypes).yq = function () {
  var tmp0 = this.t67_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.s65();
    try {
      // Inline function 'kotlin.UByte.toByte' call
      var this_0 = toUByte(input);
      tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_0);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.k64("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$2;
};
protoOf(JsonDecoderForUnsignedTypes).zq = function () {
  var tmp0 = this.t67_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.s65();
    try {
      // Inline function 'kotlin.UShort.toShort' call
      var this_0 = toUShort(input);
      tmp$ret$2 = _UShort___get_data__impl__g0245(this_0);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.k64("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$2;
};
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
  StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
  return $this;
}
function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
  return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
}
function encodeTypeInfo($this, discriminator, serialName) {
  $this.b65_1.e63();
  $this.os(discriminator);
  $this.b65_1.h63(_Char___init__impl__6a9atx(58));
  $this.b65_1.g63();
  $this.os(serialName);
}
function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
  AbstractEncoder.call(this);
  this.b65_1 = composer;
  this.c65_1 = json;
  this.d65_1 = mode;
  this.e65_1 = modeReuseCache;
  this.f65_1 = this.c65_1.zr();
  this.g65_1 = this.c65_1.p5z_1;
  this.h65_1 = false;
  this.i65_1 = null;
  this.j65_1 = null;
  var i = this.d65_1.l2_1;
  if (!(this.e65_1 == null)) {
    if (!(this.e65_1[i] === null) || !(this.e65_1[i] === this)) {
      this.e65_1[i] = this;
    }
  }
}
protoOf(StreamingJsonEncoder).s61 = function () {
  return this.c65_1;
};
protoOf(StreamingJsonEncoder).zr = function () {
  return this.f65_1;
};
protoOf(StreamingJsonEncoder).ht = function (descriptor, index) {
  return this.g65_1.b61_1;
};
protoOf(StreamingJsonEncoder).ct = function (serializer, value) {
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
    if (this.s61().p5z_1.j61_1) {
      serializer.yn(this, value);
      break $l$block;
    }
    var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer;
    var tmp;
    if (isPolymorphicSerializer) {
      tmp = !this.s61().p5z_1.r61_1.equals(ClassDiscriminatorMode_NONE_getInstance());
    } else {
      var tmp_0;
      switch (this.s61().p5z_1.r61_1.l2_1) {
        case 0:
        case 2:
          tmp_0 = false;
          break;
        case 1:
          // Inline function 'kotlin.let' call

          var it = serializer.xn().op();
          tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    }
    var needDiscriminator = tmp;
    var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.xn(), this.s61()) : null;
    var tmp_1;
    if (isPolymorphicSerializer) {
      var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
      $l$block_0: {
        // Inline function 'kotlin.requireNotNull' call
        if (value == null) {
          var message = 'Value for serializer ' + toString(serializer.xn()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
          throw IllegalArgumentException_init_$Create$(toString(message));
        } else {
          break $l$block_0;
        }
      }
      var actual = findPolymorphicSerializer_0(casted, this, value);
      if (!(baseClassDiscriminator == null)) {
        access$validateIfSealed$tPolymorphicKt(serializer, actual, baseClassDiscriminator);
        checkKind_0(actual.xn().op());
      }
      tmp_1 = isInterface(actual, SerializationStrategy) ? actual : THROW_CCE();
    } else {
      tmp_1 = serializer;
    }
    var actualSerializer = tmp_1;
    if (!(baseClassDiscriminator == null)) {
      var serialName = actualSerializer.xn().yo();
      this.i65_1 = baseClassDiscriminator;
      this.j65_1 = serialName;
    }
    actualSerializer.yn(this, value);
  }
};
protoOf(StreamingJsonEncoder).kr = function (descriptor) {
  var newMode = switchMode(this.c65_1, descriptor);
  if (!(newMode.o67_1 === _Char___init__impl__6a9atx(0))) {
    this.b65_1.h63(newMode.o67_1);
    this.b65_1.c63();
  }
  var discriminator = this.i65_1;
  if (!(discriminator == null)) {
    var tmp0_elvis_lhs = this.j65_1;
    encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.yo() : tmp0_elvis_lhs);
    this.i65_1 = null;
    this.j65_1 = null;
  }
  if (this.d65_1.equals(newMode)) {
    return this;
  }
  var tmp1_safe_receiver = this.e65_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.l2_1];
  return tmp2_elvis_lhs == null ? new StreamingJsonEncoder(this.b65_1, this.c65_1, newMode, this.e65_1) : tmp2_elvis_lhs;
};
protoOf(StreamingJsonEncoder).lr = function (descriptor) {
  if (!(this.d65_1.p67_1 === _Char___init__impl__6a9atx(0))) {
    this.b65_1.d63();
    this.b65_1.f63();
    this.b65_1.h63(this.d65_1.p67_1);
  }
};
protoOf(StreamingJsonEncoder).ds = function (descriptor, index) {
  switch (this.d65_1.l2_1) {
    case 1:
      if (!this.b65_1.b63_1) {
        this.b65_1.h63(_Char___init__impl__6a9atx(44));
      }

      this.b65_1.e63();
      break;
    case 2:
      if (!this.b65_1.b63_1) {
        var tmp = this;
        var tmp_0;
        if ((index % 2 | 0) === 0) {
          this.b65_1.h63(_Char___init__impl__6a9atx(44));
          this.b65_1.e63();
          tmp_0 = true;
        } else {
          this.b65_1.h63(_Char___init__impl__6a9atx(58));
          this.b65_1.g63();
          tmp_0 = false;
        }
        tmp.h65_1 = tmp_0;
      } else {
        this.h65_1 = true;
        this.b65_1.e63();
      }

      break;
    case 3:
      if (index === 0)
        this.h65_1 = true;
      if (index === 1) {
        this.b65_1.h63(_Char___init__impl__6a9atx(44));
        this.b65_1.g63();
        this.h65_1 = false;
      }

      break;
    default:
      if (!this.b65_1.b63_1) {
        this.b65_1.h63(_Char___init__impl__6a9atx(44));
      }

      this.b65_1.e63();
      this.os(getJsonElementName(descriptor, this.c65_1, index));
      this.b65_1.h63(_Char___init__impl__6a9atx(58));
      this.b65_1.g63();
      break;
  }
  return true;
};
protoOf(StreamingJsonEncoder).dt = function (descriptor, index, serializer, value) {
  if (!(value == null) || this.g65_1.g61_1) {
    protoOf(AbstractEncoder).dt.call(this, descriptor, index, serializer, value);
  }
};
protoOf(StreamingJsonEncoder).qs = function (descriptor) {
  var tmp;
  if (get_isUnsignedNumber(descriptor)) {
    // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
    var tmp_0;
    var tmp_1 = this.b65_1;
    if (tmp_1 instanceof ComposerForUnsignedNumbers) {
      tmp_0 = this.b65_1;
    } else {
      var tmp1 = this.b65_1.a63_1;
      var p1 = this.h65_1;
      tmp_0 = new ComposerForUnsignedNumbers(tmp1, p1);
    }
    var tmp$ret$1 = tmp_0;
    tmp = new StreamingJsonEncoder(tmp$ret$1, this.c65_1, this.d65_1, null);
  } else if (get_isUnquotedLiteral(descriptor)) {
    // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
    var tmp_2;
    var tmp_3 = this.b65_1;
    if (tmp_3 instanceof ComposerForUnquotedLiterals) {
      tmp_2 = this.b65_1;
    } else {
      var tmp4 = this.b65_1.a63_1;
      var p1_0 = this.h65_1;
      tmp_2 = new ComposerForUnquotedLiterals(tmp4, p1_0);
    }
    var tmp$ret$3 = tmp_2;
    tmp = new StreamingJsonEncoder(tmp$ret$3, this.c65_1, this.d65_1, null);
  } else if (!(this.i65_1 == null)) {
    // Inline function 'kotlin.apply' call
    this.j65_1 = descriptor.yo();
    tmp = this;
  } else {
    tmp = protoOf(AbstractEncoder).qs.call(this, descriptor);
  }
  return tmp;
};
protoOf(StreamingJsonEncoder).fs = function () {
  this.b65_1.j63('null');
};
protoOf(StreamingJsonEncoder).gs = function (value) {
  if (this.h65_1) {
    this.os(value.toString());
  } else {
    this.b65_1.s63(value);
  }
};
protoOf(StreamingJsonEncoder).hs = function (value) {
  if (this.h65_1) {
    this.os(value.toString());
  } else {
    this.b65_1.n63(value);
  }
};
protoOf(StreamingJsonEncoder).is = function (value) {
  if (this.h65_1) {
    this.os(value.toString());
  } else {
    this.b65_1.p63(value);
  }
};
protoOf(StreamingJsonEncoder).js = function (value) {
  if (this.h65_1) {
    this.os(value.toString());
  } else {
    this.b65_1.q63(value);
  }
};
protoOf(StreamingJsonEncoder).ks = function (value) {
  if (this.h65_1) {
    this.os(value.toString());
  } else {
    this.b65_1.r63(value);
  }
};
protoOf(StreamingJsonEncoder).ls = function (value) {
  if (this.h65_1) {
    this.os(value.toString());
  } else {
    this.b65_1.l63(value);
  }
  if (!this.g65_1.l61_1 && !isFinite(value)) {
    throw InvalidFloatingPointEncoded(value, toString(this.b65_1.a63_1));
  }
};
protoOf(StreamingJsonEncoder).ms = function (value) {
  if (this.h65_1) {
    this.os(value.toString());
  } else {
    this.b65_1.m63(value);
  }
  if (!this.g65_1.l61_1 && !isFinite_0(value)) {
    throw InvalidFloatingPointEncoded(value, toString(this.b65_1.a63_1));
  }
};
protoOf(StreamingJsonEncoder).ns = function (value) {
  this.os(toString_1(value));
};
protoOf(StreamingJsonEncoder).os = function (value) {
  return this.b65_1.t63(value);
};
protoOf(StreamingJsonEncoder).ps = function (enumDescriptor, index) {
  this.os(enumDescriptor.sp(index));
};
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.pp() && get_unsignedNumberDescriptors().u1(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.pp() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_0()).xn(), serializer_0(Companion_getInstance()).xn(), serializer_2(Companion_getInstance_1()).xn(), serializer_3(Companion_getInstance_2()).xn()]);
  }
}
function get_ESCAPE_STRINGS() {
  _init_properties_StringOps_kt__fcy1db();
  return ESCAPE_STRINGS;
}
var ESCAPE_STRINGS;
var ESCAPE_MARKERS;
function toHexChar(i) {
  _init_properties_StringOps_kt__fcy1db();
  var d = i & 15;
  var tmp;
  if (d < 10) {
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(48);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp = numberToChar(d + tmp$ret$0 | 0);
  } else {
    var tmp_0 = d - 10 | 0;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(97);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
    tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
  }
  return tmp;
}
function printQuoted(_this__u8e3s4, value) {
  _init_properties_StringOps_kt__fcy1db();
  _this__u8e3s4.c8(_Char___init__impl__6a9atx(34));
  var lastPos = 0;
  var inductionVariable = 0;
  var last = charSequenceLength(value) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet(value, i);
      var c = Char__toInt_impl_vasixd(this_0);
      if (c < get_ESCAPE_STRINGS().length && !(get_ESCAPE_STRINGS()[c] == null)) {
        _this__u8e3s4.fc(value, lastPos, i);
        _this__u8e3s4.b8(get_ESCAPE_STRINGS()[c]);
        lastPos = i + 1 | 0;
      }
    }
     while (inductionVariable <= last);
  if (!(lastPos === 0))
    _this__u8e3s4.fc(value, lastPos, value.length);
  else
    _this__u8e3s4.b8(value);
  _this__u8e3s4.c8(_Char___init__impl__6a9atx(34));
}
function toBooleanStrictOrNull_0(_this__u8e3s4) {
  _init_properties_StringOps_kt__fcy1db();
  return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
}
var properties_initialized_StringOps_kt_wzaea7;
function _init_properties_StringOps_kt__fcy1db() {
  if (!properties_initialized_StringOps_kt_wzaea7) {
    properties_initialized_StringOps_kt_wzaea7 = true;
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.apply' call
    var this_0 = Array(93);
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var c = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c1 = toHexChar(c >> 12);
        var c2 = toHexChar(c >> 8);
        var c3 = toHexChar(c >> 4);
        var c4 = toHexChar(c);
        this_0[c] = '\\u' + toString_1(c1) + toString_1(c2) + toString_1(c3) + toString_1(c4);
      }
       while (inductionVariable <= 31);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(34);
    this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(92);
    this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
    // Inline function 'kotlin.code' call
    var this_3 = _Char___init__impl__6a9atx(9);
    this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
    // Inline function 'kotlin.code' call
    var this_4 = _Char___init__impl__6a9atx(8);
    this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
    // Inline function 'kotlin.code' call
    var this_5 = _Char___init__impl__6a9atx(10);
    this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
    // Inline function 'kotlin.code' call
    var this_6 = _Char___init__impl__6a9atx(13);
    this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
    this_0[12] = '\\f';
    ESCAPE_STRINGS = this_0;
    // Inline function 'kotlin.apply' call
    var this_7 = new Int8Array(93);
    var inductionVariable_0 = 0;
    if (inductionVariable_0 <= 31)
      do {
        var c_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_7[c_0] = 1;
      }
       while (inductionVariable_0 <= 31);
    // Inline function 'kotlin.code' call
    var this_8 = _Char___init__impl__6a9atx(34);
    var tmp = Char__toInt_impl_vasixd(this_8);
    // Inline function 'kotlin.code' call
    var this_9 = _Char___init__impl__6a9atx(34);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_9);
    this_7[tmp] = toByte(tmp$ret$1);
    // Inline function 'kotlin.code' call
    var this_10 = _Char___init__impl__6a9atx(92);
    var tmp_0 = Char__toInt_impl_vasixd(this_10);
    // Inline function 'kotlin.code' call
    var this_11 = _Char___init__impl__6a9atx(92);
    var tmp$ret$3 = Char__toInt_impl_vasixd(this_11);
    this_7[tmp_0] = toByte(tmp$ret$3);
    // Inline function 'kotlin.code' call
    var this_12 = _Char___init__impl__6a9atx(9);
    var tmp_1 = Char__toInt_impl_vasixd(this_12);
    // Inline function 'kotlin.code' call
    var this_13 = _Char___init__impl__6a9atx(116);
    var tmp$ret$5 = Char__toInt_impl_vasixd(this_13);
    this_7[tmp_1] = toByte(tmp$ret$5);
    // Inline function 'kotlin.code' call
    var this_14 = _Char___init__impl__6a9atx(8);
    var tmp_2 = Char__toInt_impl_vasixd(this_14);
    // Inline function 'kotlin.code' call
    var this_15 = _Char___init__impl__6a9atx(98);
    var tmp$ret$7 = Char__toInt_impl_vasixd(this_15);
    this_7[tmp_2] = toByte(tmp$ret$7);
    // Inline function 'kotlin.code' call
    var this_16 = _Char___init__impl__6a9atx(10);
    var tmp_3 = Char__toInt_impl_vasixd(this_16);
    // Inline function 'kotlin.code' call
    var this_17 = _Char___init__impl__6a9atx(110);
    var tmp$ret$9 = Char__toInt_impl_vasixd(this_17);
    this_7[tmp_3] = toByte(tmp$ret$9);
    // Inline function 'kotlin.code' call
    var this_18 = _Char___init__impl__6a9atx(13);
    var tmp_4 = Char__toInt_impl_vasixd(this_18);
    // Inline function 'kotlin.code' call
    var this_19 = _Char___init__impl__6a9atx(114);
    var tmp$ret$11 = Char__toInt_impl_vasixd(this_19);
    this_7[tmp_4] = toByte(tmp$ret$11);
    // Inline function 'kotlin.code' call
    var this_20 = _Char___init__impl__6a9atx(102);
    var tmp$ret$12 = Char__toInt_impl_vasixd(this_20);
    this_7[12] = toByte(tmp$ret$12);
    ESCAPE_MARKERS = this_7;
  }
}
function readJson(json, element, deserializer) {
  var tmp;
  if (element instanceof JsonObject) {
    tmp = new JsonTreeDecoder(json, element);
  } else {
    if (element instanceof JsonArray) {
      tmp = new JsonTreeListDecoder(json, element);
    } else {
      var tmp_0;
      if (element instanceof JsonLiteral) {
        tmp_0 = true;
      } else {
        tmp_0 = equals(element, JsonNull_getInstance());
      }
      if (tmp_0) {
        tmp = new JsonPrimitiveDecoder(json, element instanceof JsonPrimitive ? element : THROW_CCE());
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  var input = tmp;
  return input.jr(deserializer);
}
function unparsedPrimitive($this, literal, primitive, tag) {
  var type = startsWith(primitive, 'i') ? 'an ' + primitive : 'a ' + primitive;
  throw JsonDecodingException_0(-1, "Failed to parse literal '" + literal.toString() + "' as " + type + ' value at element: ' + $this.b68(tag), toString($this.c68()));
}
function AbstractJsonTreeDecoder(json, value, polymorphicDiscriminator) {
  polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
  NamedValueDecoder.call(this);
  this.x67_1 = json;
  this.y67_1 = value;
  this.z67_1 = polymorphicDiscriminator;
  this.a68_1 = this.s61().p5z_1;
}
protoOf(AbstractJsonTreeDecoder).s61 = function () {
  return this.x67_1;
};
protoOf(AbstractJsonTreeDecoder).t = function () {
  return this.y67_1;
};
protoOf(AbstractJsonTreeDecoder).zr = function () {
  return this.s61().zr();
};
protoOf(AbstractJsonTreeDecoder).c68 = function () {
  var tmp0_safe_receiver = this.s15();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = this.d68(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? this.t() : tmp1_elvis_lhs;
};
protoOf(AbstractJsonTreeDecoder).b68 = function (currentTag) {
  return this.u15() + ('.' + currentTag);
};
protoOf(AbstractJsonTreeDecoder).t61 = function () {
  return this.c68();
};
protoOf(AbstractJsonTreeDecoder).jr = function (deserializer) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
    var tmp;
    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
      tmp = true;
    } else {
      tmp = this.s61().p5z_1.j61_1;
    }
    if (tmp) {
      tmp$ret$0 = deserializer.zn(this);
      break $l$block;
    }
    var discriminator = classDiscriminator(deserializer.xn(), this.s61());
    var tmp0 = this.t61();
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = deserializer.xn().yo();
    if (!(tmp0 instanceof JsonObject)) {
      var tmp_0 = getKClass(JsonObject).pa();
      var tmp_1 = getKClassFromExpression(tmp0).pa();
      var tmp$ret$1 = this.u15();
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString(tmp0));
    }
    var jsonTree = tmp0;
    var tmp0_safe_receiver = jsonTree.h2a(discriminator);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
    var tmp_2;
    try {
      tmp_2 = findPolymorphicSerializer(deserializer, this, type);
    } catch ($p) {
      var tmp_3;
      if ($p instanceof SerializationException) {
        var it = $p;
        throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
      } else {
        throw $p;
      }
    }
    var tmp_4 = tmp_2;
    var actualSerializer = isInterface(tmp_4, DeserializationStrategy) ? tmp_4 : THROW_CCE();
    tmp$ret$0 = readPolymorphicJson(this.s61(), discriminator, jsonTree, actualSerializer);
  }
  return tmp$ret$0;
};
protoOf(AbstractJsonTreeDecoder).t15 = function (parentName, childName) {
  return childName;
};
protoOf(AbstractJsonTreeDecoder).kr = function (descriptor) {
  var currentObject = this.c68();
  var tmp0_subject = descriptor.op();
  var tmp;
  var tmp_0;
  if (equals(tmp0_subject, LIST_getInstance())) {
    tmp_0 = true;
  } else {
    tmp_0 = tmp0_subject instanceof PolymorphicKind;
  }
  if (tmp_0) {
    var tmp_1 = this.s61();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = descriptor.yo();
    if (!(currentObject instanceof JsonArray)) {
      var tmp_2 = getKClass(JsonArray).pa();
      var tmp_3 = getKClassFromExpression(currentObject).pa();
      var tmp$ret$0 = this.u15();
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(currentObject));
    }
    tmp = new JsonTreeListDecoder(tmp_1, currentObject);
  } else {
    if (equals(tmp0_subject, MAP_getInstance())) {
      // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
      var this_0 = this.s61();
      var keyDescriptor = carrierDescriptor(descriptor.vp(0), this_0.zr());
      var keyKind = keyDescriptor.op();
      var tmp_4;
      var tmp_5;
      if (keyKind instanceof PrimitiveKind) {
        tmp_5 = true;
      } else {
        tmp_5 = equals(keyKind, ENUM_getInstance());
      }
      if (tmp_5) {
        var tmp_6 = this.s61();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName_0 = descriptor.yo();
        if (!(currentObject instanceof JsonObject)) {
          var tmp_7 = getKClass(JsonObject).pa();
          var tmp_8 = getKClassFromExpression(currentObject).pa();
          var tmp$ret$3 = this.u15();
          throw JsonDecodingException_0(-1, 'Expected ' + tmp_7 + ', but had ' + tmp_8 + ' as the serialized body of ' + serialName_0 + ' at element: ' + tmp$ret$3, toString(currentObject));
        }
        tmp_4 = new JsonTreeMapDecoder(tmp_6, currentObject);
      } else {
        if (this_0.p5z_1.e61_1) {
          var tmp_9 = this.s61();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName_1 = descriptor.yo();
          if (!(currentObject instanceof JsonArray)) {
            var tmp_10 = getKClass(JsonArray).pa();
            var tmp_11 = getKClassFromExpression(currentObject).pa();
            var tmp$ret$7 = this.u15();
            throw JsonDecodingException_0(-1, 'Expected ' + tmp_10 + ', but had ' + tmp_11 + ' as the serialized body of ' + serialName_1 + ' at element: ' + tmp$ret$7, toString(currentObject));
          }
          tmp_4 = new JsonTreeListDecoder(tmp_9, currentObject);
        } else {
          throw InvalidKeyKindException(keyDescriptor);
        }
      }
      tmp = tmp_4;
    } else {
      var tmp_12 = this.s61();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName_2 = descriptor.yo();
      if (!(currentObject instanceof JsonObject)) {
        var tmp_13 = getKClass(JsonObject).pa();
        var tmp_14 = getKClassFromExpression(currentObject).pa();
        var tmp$ret$12 = this.u15();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_13 + ', but had ' + tmp_14 + ' as the serialized body of ' + serialName_2 + ' at element: ' + tmp$ret$12, toString(currentObject));
      }
      tmp = new JsonTreeDecoder(tmp_12, currentObject, this.z67_1);
    }
  }
  return tmp;
};
protoOf(AbstractJsonTreeDecoder).lr = function (descriptor) {
};
protoOf(AbstractJsonTreeDecoder).vq = function () {
  var tmp = this.c68();
  return !(tmp instanceof JsonNull);
};
protoOf(AbstractJsonTreeDecoder).e68 = function (tag, enumDescriptor) {
  var tmp = this.s61();
  // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
  var tmp1 = this.d68(tag);
  // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
  // Inline function 'kotlinx.serialization.json.internal.cast' call
  var serialName = enumDescriptor.yo();
  if (!(tmp1 instanceof JsonPrimitive)) {
    var tmp_0 = getKClass(JsonPrimitive).pa();
    var tmp_1 = getKClassFromExpression(tmp1).pa();
    var tmp$ret$0 = this.b68(tag);
    throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(tmp1));
  }
  return getJsonNameIndexOrThrow(enumDescriptor, tmp, tmp1.z4u());
};
protoOf(AbstractJsonTreeDecoder).g16 = function (tag, enumDescriptor) {
  return this.e68((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
};
protoOf(AbstractJsonTreeDecoder).f68 = function (tag) {
  return !(this.d68(tag) === JsonNull_getInstance());
};
protoOf(AbstractJsonTreeDecoder).w15 = function (tag) {
  return this.f68((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).g68 = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.d68(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).pa();
      var tmp_0 = getKClassFromExpression(value).pa();
      var tmp$ret$0 = this.b68(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'boolean' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = get_booleanOrNull(literal);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'boolean', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'boolean', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$4;
};
protoOf(AbstractJsonTreeDecoder).x15 = function (tag) {
  return this.g68((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).h68 = function (tag) {
  var tmp$ret$5;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.d68(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).pa();
      var tmp_0 = getKClassFromExpression(value).pa();
      var tmp$ret$0 = this.b68(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'byte' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var result = parseLongImpl(literal);
      var tmp_1;
      // Inline function 'kotlin.ranges.contains' call
      var this_0 = numberRangeToNumber(-128, 127);
      if (contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
        tmp_1 = result.h3();
      } else {
        tmp_1 = null;
      }
      var tmp0_elvis_lhs = tmp_1;
      var tmp_2;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'byte', tag);
      } else {
        tmp_2 = tmp0_elvis_lhs;
      }
      tmp$ret$5 = tmp_2;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'byte', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$5;
};
protoOf(AbstractJsonTreeDecoder).y15 = function (tag) {
  return this.h68((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).i68 = function (tag) {
  var tmp$ret$5;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.d68(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).pa();
      var tmp_0 = getKClassFromExpression(value).pa();
      var tmp$ret$0 = this.b68(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'short' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var result = parseLongImpl(literal);
      var tmp_1;
      // Inline function 'kotlin.ranges.contains' call
      var this_0 = numberRangeToNumber(-32768, 32767);
      if (contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
        tmp_1 = result.i3();
      } else {
        tmp_1 = null;
      }
      var tmp0_elvis_lhs = tmp_1;
      var tmp_2;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'short', tag);
      } else {
        tmp_2 = tmp0_elvis_lhs;
      }
      tmp$ret$5 = tmp_2;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'short', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$5;
};
protoOf(AbstractJsonTreeDecoder).z15 = function (tag) {
  return this.i68((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).j68 = function (tag) {
  var tmp$ret$5;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.d68(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).pa();
      var tmp_0 = getKClassFromExpression(value).pa();
      var tmp$ret$0 = this.b68(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'int' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var result = parseLongImpl(literal);
      var tmp_1;
      // Inline function 'kotlin.ranges.contains' call
      var this_0 = numberRangeToNumber(-2147483648, 2147483647);
      if (contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
        tmp_1 = result.d1();
      } else {
        tmp_1 = null;
      }
      var tmp0_elvis_lhs = tmp_1;
      var tmp_2;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'int', tag);
      } else {
        tmp_2 = tmp0_elvis_lhs;
      }
      tmp$ret$5 = tmp_2;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'int', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$5;
};
protoOf(AbstractJsonTreeDecoder).a16 = function (tag) {
  return this.j68((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).k68 = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.d68(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).pa();
      var tmp_0 = getKClassFromExpression(value).pa();
      var tmp$ret$0 = this.b68(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'long' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = parseLongImpl(literal);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'long', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'long', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$4;
};
protoOf(AbstractJsonTreeDecoder).b16 = function (tag) {
  return this.k68((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).l68 = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.d68(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).pa();
      var tmp_0 = getKClassFromExpression(value).pa();
      var tmp$ret$0 = this.b68(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'float' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = get_float(literal);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'float', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'float', tag);
      } else {
        throw $p;
      }
    }
  }
  var result = tmp$ret$4;
  var specialFp = this.s61().p5z_1.l61_1;
  if (specialFp || isFinite(result))
    return result;
  throw InvalidFloatingPointDecoded(result, tag, toString(this.c68()));
};
protoOf(AbstractJsonTreeDecoder).c16 = function (tag) {
  return this.l68((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).m68 = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.d68(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).pa();
      var tmp_0 = getKClassFromExpression(value).pa();
      var tmp$ret$0 = this.b68(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'double' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = get_double(literal);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'double', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'double', tag);
      } else {
        throw $p;
      }
    }
  }
  var result = tmp$ret$4;
  var specialFp = this.s61().p5z_1.l61_1;
  if (specialFp || isFinite_0(result))
    return result;
  throw InvalidFloatingPointDecoded(result, tag, toString(this.c68()));
};
protoOf(AbstractJsonTreeDecoder).d16 = function (tag) {
  return this.m68((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).n68 = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.d68(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).pa();
      var tmp_0 = getKClassFromExpression(value).pa();
      var tmp$ret$0 = this.b68(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'char' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = new Char(single(literal.z4u()));
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'char', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1.i1_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'char', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$4;
};
protoOf(AbstractJsonTreeDecoder).e16 = function (tag) {
  return this.n68((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).o68 = function (tag) {
  // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
  // Inline function 'kotlinx.serialization.json.internal.cast' call
  var value = this.d68(tag);
  if (!(value instanceof JsonPrimitive)) {
    var tmp = getKClass(JsonPrimitive).pa();
    var tmp_0 = getKClassFromExpression(value).pa();
    var tmp$ret$0 = this.b68(tag);
    throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'string' + ' at element: ' + tmp$ret$0, toString(value));
  }
  var value_0 = value;
  if (!(value_0 instanceof JsonLiteral))
    throw JsonDecodingException_0(-1, "Expected string value for a non-null key '" + tag + "', got null literal instead at element: " + this.b68(tag), toString(this.c68()));
  if (!value_0.b62_1 && !this.s61().p5z_1.d61_1) {
    throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted at element: " + this.b68(tag) + ".\nUse 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.", toString(this.c68()));
  }
  return value_0.d62_1;
};
protoOf(AbstractJsonTreeDecoder).f16 = function (tag) {
  return this.o68((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).p68 = function (tag, inlineDescriptor) {
  var tmp;
  if (get_isUnsignedNumber(inlineDescriptor)) {
    var tmp_0 = this.s61();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    var tmp1 = this.d68(tag);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = inlineDescriptor.yo();
    if (!(tmp1 instanceof JsonPrimitive)) {
      var tmp_1 = getKClass(JsonPrimitive).pa();
      var tmp_2 = getKClassFromExpression(tmp1).pa();
      var tmp$ret$0 = this.b68(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_1 + ', but had ' + tmp_2 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(tmp1));
    }
    var lexer = StringJsonLexer_0(tmp_0, tmp1.z4u());
    tmp = new JsonDecoderForUnsignedTypes(lexer, this.s61());
  } else {
    tmp = protoOf(NamedValueDecoder).h16.call(this, tag, inlineDescriptor);
  }
  return tmp;
};
protoOf(AbstractJsonTreeDecoder).h16 = function (tag, inlineDescriptor) {
  return this.p68((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
};
protoOf(AbstractJsonTreeDecoder).hr = function (descriptor) {
  return !(this.s15() == null) ? protoOf(NamedValueDecoder).hr.call(this, descriptor) : (new JsonPrimitiveDecoder(this.s61(), this.t(), this.z67_1)).hr(descriptor);
};
function setForceNull($this, descriptor, index) {
  $this.z68_1 = (!$this.s61().p5z_1.g61_1 && !descriptor.wp(index) && descriptor.vp(index).kp());
  return $this.z68_1;
}
function JsonTreeDecoder(json, value, polymorphicDiscriminator, polyDescriptor) {
  polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
  polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
  AbstractJsonTreeDecoder.call(this, json, value, polymorphicDiscriminator);
  this.w68_1 = value;
  this.x68_1 = polyDescriptor;
  this.y68_1 = 0;
  this.z68_1 = false;
}
protoOf(JsonTreeDecoder).t = function () {
  return this.w68_1;
};
protoOf(JsonTreeDecoder).bs = function (descriptor) {
  $l$loop: while (this.y68_1 < descriptor.qp()) {
    var _unary__edvuaz = this.y68_1;
    this.y68_1 = _unary__edvuaz + 1 | 0;
    var name = this.n15(descriptor, _unary__edvuaz);
    var index = this.y68_1 - 1 | 0;
    this.z68_1 = false;
    var tmp;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.t();
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).y1(name)) {
      tmp = true;
    } else {
      tmp = setForceNull(this, descriptor, index);
    }
    if (tmp) {
      if (!this.a68_1.i61_1)
        return index;
      var tmp2 = this.s61();
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
        var isOptional = descriptor.wp(index);
        var elementDescriptor = descriptor.vp(index);
        var tmp_0;
        if (isOptional && !elementDescriptor.kp()) {
          var tmp_1 = this.a69(name);
          tmp_0 = tmp_1 instanceof JsonNull;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$3 = true;
          break $l$block_2;
        }
        if (equals(elementDescriptor.op(), ENUM_getInstance())) {
          var tmp_2;
          if (elementDescriptor.kp()) {
            var tmp_3 = this.a69(name);
            tmp_2 = tmp_3 instanceof JsonNull;
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp$ret$3 = false;
            break $l$block_2;
          }
          var tmp_4 = this.a69(name);
          var tmp0_safe_receiver = tmp_4 instanceof JsonPrimitive ? tmp_4 : null;
          var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
          var tmp_5;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$3 = false;
            break $l$block_2;
          } else {
            tmp_5 = tmp0_elvis_lhs;
          }
          var enumValue = tmp_5;
          var enumIndex = getJsonNameIndex(elementDescriptor, tmp2, enumValue);
          var coerceToNull = !tmp2.p5z_1.g61_1 && elementDescriptor.kp();
          if (enumIndex === -3 && (isOptional || coerceToNull)) {
            if (setForceNull(this, descriptor, index))
              return index;
            tmp$ret$3 = true;
            break $l$block_2;
          }
        }
        tmp$ret$3 = false;
      }
      if (tmp$ret$3)
        continue $l$loop;
      return index;
    }
  }
  return -1;
};
protoOf(JsonTreeDecoder).vq = function () {
  return !this.z68_1 && protoOf(AbstractJsonTreeDecoder).vq.call(this);
};
protoOf(JsonTreeDecoder).o15 = function (descriptor, index) {
  var strategy = namingStrategy(descriptor, this.s61());
  var baseName = descriptor.sp(index);
  if (strategy == null) {
    if (!this.a68_1.m61_1)
      return baseName;
    if (this.t().b2().u1(baseName))
      return baseName;
  }
  var deserializationNamesMap_0 = deserializationNamesMap(this.s61(), descriptor);
  // Inline function 'kotlin.collections.find' call
  var tmp0 = this.t().b2();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (deserializationNamesMap_0.a2(element) === index) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp0_safe_receiver;
  }
  var fallbackName = strategy == null ? null : strategy.o64(descriptor, index, baseName);
  return fallbackName == null ? baseName : fallbackName;
};
protoOf(JsonTreeDecoder).d68 = function (tag) {
  return getValue(this.t(), tag);
};
protoOf(JsonTreeDecoder).a69 = function (tag) {
  return this.t().h2a(tag);
};
protoOf(JsonTreeDecoder).kr = function (descriptor) {
  if (descriptor === this.x68_1) {
    var tmp = this.s61();
    var tmp1 = this.c68();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = this.x68_1.yo();
    if (!(tmp1 instanceof JsonObject)) {
      var tmp_0 = getKClass(JsonObject).pa();
      var tmp_1 = getKClassFromExpression(tmp1).pa();
      var tmp$ret$0 = this.u15();
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(tmp1));
    }
    return new JsonTreeDecoder(tmp, tmp1, this.z67_1, this.x68_1);
  }
  return protoOf(AbstractJsonTreeDecoder).kr.call(this, descriptor);
};
protoOf(JsonTreeDecoder).lr = function (descriptor) {
  var tmp;
  if (ignoreUnknownKeys(descriptor, this.s61())) {
    tmp = true;
  } else {
    var tmp_0 = descriptor.op();
    tmp = tmp_0 instanceof PolymorphicKind;
  }
  if (tmp)
    return Unit_instance;
  var strategy = namingStrategy(descriptor, this.s61());
  var tmp_1;
  if (strategy == null && !this.a68_1.m61_1) {
    tmp_1 = jsonCachedSerialNames(descriptor);
  } else if (!(strategy == null)) {
    tmp_1 = deserializationNamesMap(this.s61(), descriptor).b2();
  } else {
    var tmp_2 = jsonCachedSerialNames(descriptor);
    var tmp0_safe_receiver = get_schemaCache(this.s61()).b67(descriptor, get_JsonDeserializationNamesKey());
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b2();
    var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
    tmp_1 = plus_0(tmp_2, tmp$ret$0);
  }
  var names = tmp_1;
  var _iterator__ex2g4s = this.t().b2().j();
  while (_iterator__ex2g4s.k()) {
    var key = _iterator__ex2g4s.l();
    if (!names.u1(key) && !(key === this.z67_1)) {
      throw JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "' at element: " + this.u15() + '\n' + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.\n" + ('JSON input: ' + toString(minify(this.t().toString()))));
    }
  }
};
function JsonTreeListDecoder(json, value) {
  AbstractJsonTreeDecoder.call(this, json, value);
  this.h69_1 = value;
  this.i69_1 = this.h69_1.m();
  this.j69_1 = -1;
}
protoOf(JsonTreeListDecoder).t = function () {
  return this.h69_1;
};
protoOf(JsonTreeListDecoder).o15 = function (descriptor, index) {
  return index.toString();
};
protoOf(JsonTreeListDecoder).d68 = function (tag) {
  return this.h69_1.o(toInt(tag));
};
protoOf(JsonTreeListDecoder).bs = function (descriptor) {
  while (this.j69_1 < (this.i69_1 - 1 | 0)) {
    this.j69_1 = this.j69_1 + 1 | 0;
    return this.j69_1;
  }
  return -1;
};
function JsonPrimitiveDecoder(json, value, polymorphicDiscriminator) {
  polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
  AbstractJsonTreeDecoder.call(this, json, value, polymorphicDiscriminator);
  this.q69_1 = value;
  this.i16('primitive');
}
protoOf(JsonPrimitiveDecoder).t = function () {
  return this.q69_1;
};
protoOf(JsonPrimitiveDecoder).bs = function (descriptor) {
  return 0;
};
protoOf(JsonPrimitiveDecoder).d68 = function (tag) {
  // Inline function 'kotlin.require' call
  if (!(tag === 'primitive')) {
    var message = "This input can only handle primitives with 'primitive' tag";
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return this.q69_1;
};
function JsonTreeMapDecoder(json, value) {
  JsonTreeDecoder.call(this, json, value);
  this.b6a_1 = value;
  this.c6a_1 = toList(this.b6a_1.b2());
  this.d6a_1 = imul(this.c6a_1.m(), 2);
  this.e6a_1 = -1;
}
protoOf(JsonTreeMapDecoder).t = function () {
  return this.b6a_1;
};
protoOf(JsonTreeMapDecoder).o15 = function (descriptor, index) {
  var i = index / 2 | 0;
  return this.c6a_1.o(i);
};
protoOf(JsonTreeMapDecoder).bs = function (descriptor) {
  while (this.e6a_1 < (this.d6a_1 - 1 | 0)) {
    this.e6a_1 = this.e6a_1 + 1 | 0;
    return this.e6a_1;
  }
  return -1;
};
protoOf(JsonTreeMapDecoder).d68 = function (tag) {
  return (this.e6a_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.b6a_1, tag);
};
protoOf(JsonTreeMapDecoder).lr = function (descriptor) {
};
function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
  return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.xn())).jr(deserializer);
}
var WriteMode_OBJ_instance;
var WriteMode_LIST_instance;
var WriteMode_MAP_instance;
var WriteMode_POLY_OBJ_instance;
function values() {
  return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var WriteMode_entriesInitialized;
function WriteMode_initEntries() {
  if (WriteMode_entriesInitialized)
    return Unit_instance;
  WriteMode_entriesInitialized = true;
  WriteMode_OBJ_instance = new WriteMode('OBJ', 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  WriteMode_LIST_instance = new WriteMode('LIST', 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
  WriteMode_MAP_instance = new WriteMode('MAP', 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
}
var $ENTRIES;
function WriteMode(name, ordinal, begin, end) {
  Enum.call(this, name, ordinal);
  this.o67_1 = begin;
  this.p67_1 = end;
}
function switchMode(_this__u8e3s4, desc) {
  var tmp0_subject = desc.op();
  var tmp;
  if (tmp0_subject instanceof PolymorphicKind) {
    tmp = WriteMode_POLY_OBJ_getInstance();
  } else {
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp = WriteMode_LIST_getInstance();
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var keyDescriptor = carrierDescriptor(desc.vp(0), _this__u8e3s4.zr());
        var keyKind = keyDescriptor.op();
        var tmp_0;
        var tmp_1;
        if (keyKind instanceof PrimitiveKind) {
          tmp_1 = true;
        } else {
          tmp_1 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_1) {
          tmp_0 = WriteMode_MAP_getInstance();
        } else {
          if (_this__u8e3s4.p5z_1.e61_1) {
            tmp_0 = WriteMode_LIST_getInstance();
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_0;
      } else {
        tmp = WriteMode_OBJ_getInstance();
      }
    }
  }
  return tmp;
}
function carrierDescriptor(_this__u8e3s4, module_0) {
  var tmp;
  if (equals(_this__u8e3s4.op(), CONTEXTUAL_getInstance())) {
    var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
    tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
  } else if (_this__u8e3s4.pp()) {
    tmp = carrierDescriptor(_this__u8e3s4.vp(0), module_0);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function WriteMode_OBJ_getInstance() {
  WriteMode_initEntries();
  return WriteMode_OBJ_instance;
}
function WriteMode_LIST_getInstance() {
  WriteMode_initEntries();
  return WriteMode_LIST_instance;
}
function WriteMode_MAP_getInstance() {
  WriteMode_initEntries();
  return WriteMode_MAP_instance;
}
function WriteMode_POLY_OBJ_getInstance() {
  WriteMode_initEntries();
  return WriteMode_POLY_OBJ_instance;
}
function appendEscape($this, lastPosition, current) {
  $this.f6a(lastPosition, current);
  return appendEsc($this, current + 1 | 0);
}
function decodedString($this, lastPosition, currentPosition) {
  $this.f6a(lastPosition, currentPosition);
  var result = $this.g60_1.toString();
  $this.g60_1.lc(0);
  return result;
}
function takePeeked($this) {
  // Inline function 'kotlin.also' call
  var this_0 = ensureNotNull($this.f60_1);
  $this.f60_1 = null;
  return this_0;
}
function wasUnquotedString($this) {
  return !(charSequenceGet($this.g6a(), $this.d60_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
}
function appendEsc($this, startPosition) {
  var currentPosition = startPosition;
  currentPosition = $this.h6a(currentPosition);
  if (currentPosition === -1) {
    $this.k64('Expected escape sequence to continue, got EOF');
  }
  var tmp = $this.g6a();
  var _unary__edvuaz = currentPosition;
  currentPosition = _unary__edvuaz + 1 | 0;
  var currentChar = charSequenceGet(tmp, _unary__edvuaz);
  if (currentChar === _Char___init__impl__6a9atx(117)) {
    return appendHex($this, $this.g6a(), currentPosition);
  }
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
  var c = escapeToChar(tmp$ret$0);
  if (c === _Char___init__impl__6a9atx(0)) {
    $this.k64("Invalid escaped char '" + toString_1(currentChar) + "'");
  }
  $this.g60_1.c8(c);
  return currentPosition;
}
function appendHex($this, source, startPos) {
  if ((startPos + 4 | 0) >= charSequenceLength(source)) {
    $this.d60_1 = startPos;
    $this.i6a();
    if (($this.d60_1 + 4 | 0) >= charSequenceLength(source)) {
      $this.k64('Unexpected EOF during unicode escape');
    }
    return appendHex($this, source, $this.d60_1);
  }
  $this.g60_1.c8(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
  return startPos + 4 | 0;
}
function fromHexChar($this, source, currentPosition) {
  var character = charSequenceGet(source, currentPosition);
  var tmp;
  if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
    // Inline function 'kotlin.code' call
    var tmp_0 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(48);
    tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
  } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
    // Inline function 'kotlin.code' call
    var tmp_1 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(97);
    tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
  } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
    // Inline function 'kotlin.code' call
    var tmp_2 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(65);
    tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
  } else {
    $this.k64("Invalid toHexChar char '" + toString_1(character) + "' in unicode escape");
  }
  return tmp;
}
function consumeBoolean2($this, start) {
  var current = $this.h6a(start);
  if (current >= charSequenceLength($this.g6a()) || current === -1) {
    $this.k64('EOF');
  }
  var tmp = $this.g6a();
  var _unary__edvuaz = current;
  current = _unary__edvuaz + 1 | 0;
  // Inline function 'kotlin.code' call
  var this_0 = charSequenceGet(tmp, _unary__edvuaz);
  var tmp0_subject = Char__toInt_impl_vasixd(this_0) | 32;
  var tmp_0;
  // Inline function 'kotlin.code' call
  var this_1 = _Char___init__impl__6a9atx(116);
  if (tmp0_subject === Char__toInt_impl_vasixd(this_1)) {
    consumeBooleanLiteral($this, 'rue', current);
    tmp_0 = true;
  } else {
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(102);
    if (tmp0_subject === Char__toInt_impl_vasixd(this_2)) {
      consumeBooleanLiteral($this, 'alse', current);
      tmp_0 = false;
    } else {
      $this.k64("Expected valid boolean literal prefix, but had '" + $this.s65() + "'");
    }
  }
  return tmp_0;
}
function consumeBooleanLiteral($this, literalSuffix, current) {
  if ((charSequenceLength($this.g6a()) - current | 0) < literalSuffix.length) {
    $this.k64('Unexpected end of boolean literal');
  }
  var inductionVariable = 0;
  var last = charSequenceLength(literalSuffix) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var expected = charSequenceGet(literalSuffix, i);
      var actual = charSequenceGet($this.g6a(), current + i | 0);
      // Inline function 'kotlin.code' call
      var tmp = Char__toInt_impl_vasixd(expected);
      // Inline function 'kotlin.code' call
      if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
        $this.k64("Expected valid boolean literal prefix, but had '" + $this.s65() + "'");
      }
    }
     while (inductionVariable <= last);
  $this.d60_1 = current + literalSuffix.length | 0;
}
function consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive) {
  var tmp;
  switch (isExponentPositive) {
    case false:
      // Inline function 'kotlin.math.pow' call

      var x = -exponentAccumulator.j3();
      tmp = Math.pow(10.0, x);
      break;
    case true:
      // Inline function 'kotlin.math.pow' call

      var x_0 = exponentAccumulator.j3();
      tmp = Math.pow(10.0, x_0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function AbstractJsonLexer() {
  this.d60_1 = 0;
  this.e60_1 = new JsonPath();
  this.f60_1 = null;
  this.g60_1 = StringBuilder_init_$Create$();
}
protoOf(AbstractJsonLexer).i6a = function () {
};
protoOf(AbstractJsonLexer).e67 = function () {
  var current = this.j6a();
  var source = this.g6a();
  if (current >= charSequenceLength(source) || current === -1)
    return false;
  if (charSequenceGet(source, current) === _Char___init__impl__6a9atx(44)) {
    this.d60_1 = this.d60_1 + 1 | 0;
    return true;
  }
  return false;
};
protoOf(AbstractJsonLexer).k6a = function (c) {
  return c === _Char___init__impl__6a9atx(125) || c === _Char___init__impl__6a9atx(93) || (c === _Char___init__impl__6a9atx(58) || c === _Char___init__impl__6a9atx(44)) ? false : true;
};
protoOf(AbstractJsonLexer).h60 = function () {
  var nextToken = this.u65();
  if (!(nextToken === 10)) {
    this.k64('Expected EOF after parsing, but had ' + toString_1(charSequenceGet(this.g6a(), this.d60_1 - 1 | 0)) + ' instead');
  }
};
protoOf(AbstractJsonLexer).o65 = function (expected) {
  var token = this.u65();
  if (!(token === expected)) {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
    var expected_0 = tokenDescription(expected);
    var position = true ? this.d60_1 - 1 | 0 : this.d60_1;
    var s = this.d60_1 === charSequenceLength(this.g6a()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.g6a(), position));
    var tmp$ret$0 = 'Expected ' + expected_0 + ", but had '" + s + "' instead";
    this.k64(tmp$ret$0, position);
  }
  return token;
};
protoOf(AbstractJsonLexer).l6a = function (expected) {
  if (this.d60_1 > 0 && expected === _Char___init__impl__6a9atx(34)) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.withPositionRollback' call
      var snapshot = this.d60_1;
      try {
        this.d60_1 = this.d60_1 - 1 | 0;
        tmp$ret$1 = this.s65();
        break $l$block;
      }finally {
        this.d60_1 = snapshot;
      }
    }
    var inputLiteral = tmp$ret$1;
    if (inputLiteral === 'null') {
      this.j64("Expected string literal but 'null' literal was found", this.d60_1 - 1 | 0, "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.");
    }
  }
  // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
  var expectedToken = charToTokenClass(expected);
  var expected_0 = tokenDescription(expectedToken);
  var position = true ? this.d60_1 - 1 | 0 : this.d60_1;
  var s = this.d60_1 === charSequenceLength(this.g6a()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.g6a(), position));
  var tmp$ret$2 = 'Expected ' + expected_0 + ", but had '" + s + "' instead";
  this.k64(tmp$ret$2, position);
};
protoOf(AbstractJsonLexer).p65 = function () {
  var source = this.g6a();
  var cpos = this.d60_1;
  $l$loop_0: while (true) {
    cpos = this.h6a(cpos);
    if (cpos === -1)
      break $l$loop_0;
    var ch = charSequenceGet(source, cpos);
    if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
      cpos = cpos + 1 | 0;
      continue $l$loop_0;
    }
    this.d60_1 = cpos;
    return charToTokenClass(ch);
  }
  this.d60_1 = cpos;
  return 10;
};
protoOf(AbstractJsonLexer).f67 = function (doConsume) {
  var current = this.j6a();
  current = this.h6a(current);
  var len = charSequenceLength(this.g6a()) - current | 0;
  if (len < 4 || current === -1)
    return false;
  var inductionVariable = 0;
  if (inductionVariable <= 3)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(charSequenceGet('null', i) === charSequenceGet(this.g6a(), current + i | 0)))
        return false;
    }
     while (inductionVariable <= 3);
  if (len > 4 && charToTokenClass(charSequenceGet(this.g6a(), current + 4 | 0)) === 0)
    return false;
  if (doConsume) {
    this.d60_1 = current + 4 | 0;
  }
  return true;
};
protoOf(AbstractJsonLexer).q67 = function (doConsume, $super) {
  doConsume = doConsume === VOID ? true : doConsume;
  return $super === VOID ? this.f67(doConsume) : $super.f67.call(this, doConsume);
};
protoOf(AbstractJsonLexer).g67 = function (isLenient) {
  var token = this.p65();
  var tmp;
  if (isLenient) {
    if (!(token === 1) && !(token === 0))
      return null;
    tmp = this.s65();
  } else {
    if (!(token === 1))
      return null;
    tmp = this.r65();
  }
  var string = tmp;
  this.f60_1 = string;
  return string;
};
protoOf(AbstractJsonLexer).m6a = function () {
  this.f60_1 = null;
};
protoOf(AbstractJsonLexer).b38 = function (startPos, endPos) {
  // Inline function 'kotlin.text.substring' call
  var this_0 = this.g6a();
  return toString(charSequenceSubSequence(this_0, startPos, endPos));
};
protoOf(AbstractJsonLexer).r65 = function () {
  if (!(this.f60_1 == null)) {
    return takePeeked(this);
  }
  return this.j67();
};
protoOf(AbstractJsonLexer).consumeString2 = function (source, startPosition, current) {
  var currentPosition = current;
  var lastPosition = startPosition;
  var char = charSequenceGet(source, currentPosition);
  var usedAppend = false;
  while (!(char === _Char___init__impl__6a9atx(34))) {
    if (char === _Char___init__impl__6a9atx(92)) {
      usedAppend = true;
      currentPosition = this.h6a(appendEscape(this, lastPosition, currentPosition));
      if (currentPosition === -1) {
        this.k64('Unexpected EOF', currentPosition);
      }
      lastPosition = currentPosition;
    } else {
      currentPosition = currentPosition + 1 | 0;
      if (currentPosition >= charSequenceLength(source)) {
        usedAppend = true;
        this.f6a(lastPosition, currentPosition);
        currentPosition = this.h6a(currentPosition);
        if (currentPosition === -1) {
          this.k64('Unexpected EOF', currentPosition);
        }
        lastPosition = currentPosition;
      }
    }
    char = charSequenceGet(source, currentPosition);
  }
  var tmp;
  if (!usedAppend) {
    tmp = this.b38(lastPosition, currentPosition);
  } else {
    tmp = decodedString(this, lastPosition, currentPosition);
  }
  var string = tmp;
  this.d60_1 = currentPosition + 1 | 0;
  return string;
};
protoOf(AbstractJsonLexer).k67 = function () {
  var result = this.s65();
  if (result === 'null' && wasUnquotedString(this)) {
    this.k64("Unexpected 'null' value instead of string literal");
  }
  return result;
};
protoOf(AbstractJsonLexer).s65 = function () {
  if (!(this.f60_1 == null)) {
    return takePeeked(this);
  }
  var current = this.j6a();
  if (current >= charSequenceLength(this.g6a()) || current === -1) {
    this.k64('EOF', current);
  }
  var token = charToTokenClass(charSequenceGet(this.g6a(), current));
  if (token === 1) {
    return this.r65();
  }
  if (!(token === 0)) {
    this.k64('Expected beginning of the string, but got ' + toString_1(charSequenceGet(this.g6a(), current)));
  }
  var usedAppend = false;
  while (charToTokenClass(charSequenceGet(this.g6a(), current)) === 0) {
    current = current + 1 | 0;
    if (current >= charSequenceLength(this.g6a())) {
      usedAppend = true;
      this.f6a(this.d60_1, current);
      var eof = this.h6a(current);
      if (eof === -1) {
        this.d60_1 = current;
        return decodedString(this, 0, 0);
      } else {
        current = eof;
      }
    }
  }
  var tmp;
  if (!usedAppend) {
    tmp = this.b38(this.d60_1, current);
  } else {
    tmp = decodedString(this, this.d60_1, current);
  }
  var result = tmp;
  this.d60_1 = current;
  return result;
};
protoOf(AbstractJsonLexer).f6a = function (fromIndex, toIndex) {
  this.g60_1.fc(this.g6a(), fromIndex, toIndex);
};
protoOf(AbstractJsonLexer).i67 = function (allowLenientStrings) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var tokenStack = ArrayList_init_$Create$();
  var lastToken = this.p65();
  if (!(lastToken === 8) && !(lastToken === 6)) {
    this.s65();
    return Unit_instance;
  }
  $l$loop: while (true) {
    lastToken = this.p65();
    if (lastToken === 1) {
      if (allowLenientStrings)
        this.s65();
      else
        this.j67();
      continue $l$loop;
    }
    var tmp0_subject = lastToken;
    if (tmp0_subject === 8 || tmp0_subject === 6) {
      tokenStack.e(lastToken);
    } else if (tmp0_subject === 9) {
      if (!(last(tokenStack) === 8))
        throw JsonDecodingException_0(this.d60_1, 'found ] instead of } at path: ' + this.e60_1.toString(), this.g6a());
      removeLast(tokenStack);
    } else if (tmp0_subject === 7) {
      if (!(last(tokenStack) === 6))
        throw JsonDecodingException_0(this.d60_1, 'found } instead of ] at path: ' + this.e60_1.toString(), this.g6a());
      removeLast(tokenStack);
    } else if (tmp0_subject === 10) {
      this.k64('Unexpected end of input due to malformed JSON during ignoring unknown keys');
    }
    this.u65();
    if (tokenStack.m() === 0)
      return Unit_instance;
  }
};
protoOf(AbstractJsonLexer).toString = function () {
  return "JsonReader(source='" + toString(this.g6a()) + "', currentPosition=" + this.d60_1 + ')';
};
protoOf(AbstractJsonLexer).h67 = function (key) {
  var processed = this.b38(0, this.d60_1);
  var lastIndexOf_0 = lastIndexOf(processed, key);
  throw new JsonDecodingException("Encountered an unknown key '" + key + "' at offset " + lastIndexOf_0 + ' at path: ' + this.e60_1.x64() + "\nUse 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.\n" + ('JSON input: ' + toString(minify(this.g6a(), lastIndexOf_0))));
};
protoOf(AbstractJsonLexer).j64 = function (message, position, hint) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(hint) === 0) {
    tmp = '';
  } else {
    tmp = '\n' + hint;
  }
  var hintMessage = tmp;
  throw JsonDecodingException_0(position, message + ' at path: ' + this.e60_1.x64() + hintMessage, this.g6a());
};
protoOf(AbstractJsonLexer).k64 = function (message, position, hint, $super) {
  position = position === VOID ? this.d60_1 : position;
  hint = hint === VOID ? '' : hint;
  return $super === VOID ? this.j64(message, position, hint) : $super.j64.call(this, message, position, hint);
};
protoOf(AbstractJsonLexer).s67 = function () {
  var current = this.j6a();
  current = this.h6a(current);
  if (current >= charSequenceLength(this.g6a()) || current === -1) {
    this.k64('EOF');
  }
  var tmp;
  if (charSequenceGet(this.g6a(), current) === _Char___init__impl__6a9atx(34)) {
    current = current + 1 | 0;
    if (current === charSequenceLength(this.g6a())) {
      this.k64('EOF');
    }
    tmp = true;
  } else {
    tmp = false;
  }
  var hasQuotation = tmp;
  var accumulator = new Long(0, 0);
  var exponentAccumulator = new Long(0, 0);
  var isNegative = false;
  var isExponentPositive = false;
  var hasExponent = false;
  var start = current;
  $l$loop_4: while (!(current === charSequenceLength(this.g6a()))) {
    var ch = charSequenceGet(this.g6a(), current);
    if ((ch === _Char___init__impl__6a9atx(101) || ch === _Char___init__impl__6a9atx(69)) && !hasExponent) {
      if (current === start) {
        this.k64('Unexpected symbol ' + toString_1(ch) + ' in numeric literal');
      }
      isExponentPositive = true;
      hasExponent = true;
      current = current + 1 | 0;
      continue $l$loop_4;
    }
    if (ch === _Char___init__impl__6a9atx(45) && hasExponent) {
      if (current === start) {
        this.k64("Unexpected symbol '-' in numeric literal");
      }
      isExponentPositive = false;
      current = current + 1 | 0;
      continue $l$loop_4;
    }
    if (ch === _Char___init__impl__6a9atx(43) && hasExponent) {
      if (current === start) {
        this.k64("Unexpected symbol '+' in numeric literal");
      }
      isExponentPositive = true;
      current = current + 1 | 0;
      continue $l$loop_4;
    }
    if (ch === _Char___init__impl__6a9atx(45)) {
      if (!(current === start)) {
        this.k64("Unexpected symbol '-' in numeric literal");
      }
      isNegative = true;
      current = current + 1 | 0;
      continue $l$loop_4;
    }
    var token = charToTokenClass(ch);
    if (!(token === 0))
      break $l$loop_4;
    current = current + 1 | 0;
    var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
    if (!(0 <= digit ? digit <= 9 : false)) {
      this.k64("Unexpected symbol '" + toString_1(ch) + "' in numeric literal");
    }
    if (hasExponent) {
      // Inline function 'kotlin.Long.times' call
      // Inline function 'kotlin.Long.plus' call
      exponentAccumulator = exponentAccumulator.t2(toLong(10)).r2(toLong(digit));
      continue $l$loop_4;
    }
    // Inline function 'kotlin.Long.times' call
    // Inline function 'kotlin.Long.minus' call
    accumulator = accumulator.t2(toLong(10)).s2(toLong(digit));
    if (accumulator.b1(new Long(0, 0)) > 0) {
      this.k64('Numeric value overflow');
    }
  }
  var hasChars = !(current === start);
  if (start === current || (isNegative && start === (current - 1 | 0))) {
    this.k64('Expected numeric literal');
  }
  if (hasQuotation) {
    if (!hasChars) {
      this.k64('EOF');
    }
    if (!(charSequenceGet(this.g6a(), current) === _Char___init__impl__6a9atx(34))) {
      this.k64('Expected closing quotation mark');
    }
    current = current + 1 | 0;
  }
  this.d60_1 = current;
  if (hasExponent) {
    var doubleAccumulator = accumulator.j3() * consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive);
    if (doubleAccumulator > (new Long(-1, 2147483647)).j3() || doubleAccumulator < (new Long(0, -2147483648)).j3()) {
      this.k64('Numeric value overflow');
    }
    // Inline function 'kotlin.math.floor' call
    if (!(Math.floor(doubleAccumulator) === doubleAccumulator)) {
      this.k64("Can't convert " + doubleAccumulator + ' to Long');
    }
    accumulator = numberToLong(doubleAccumulator);
  }
  var tmp_0;
  if (isNegative) {
    tmp_0 = accumulator;
  } else if (!accumulator.equals(new Long(0, -2147483648))) {
    tmp_0 = accumulator.y2();
  } else {
    this.k64('Numeric value overflow');
  }
  return tmp_0;
};
protoOf(AbstractJsonLexer).e62 = function () {
  var result = this.s67();
  var next = this.u65();
  if (!(next === 10)) {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
    var expected = tokenDescription(10);
    var position = true ? this.d60_1 - 1 | 0 : this.d60_1;
    var s = this.d60_1 === charSequenceLength(this.g6a()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.g6a(), position));
    var tmp$ret$0 = "Expected input to contain a single valid number, but got '" + s + "' after it";
    this.k64(tmp$ret$0, position);
  }
  return result;
};
protoOf(AbstractJsonLexer).r67 = function () {
  var current = this.j6a();
  if (current === charSequenceLength(this.g6a())) {
    this.k64('EOF');
  }
  var tmp;
  if (charSequenceGet(this.g6a(), current) === _Char___init__impl__6a9atx(34)) {
    current = current + 1 | 0;
    tmp = true;
  } else {
    tmp = false;
  }
  var hasQuotation = tmp;
  var result = consumeBoolean2(this, current);
  if (hasQuotation) {
    if (this.d60_1 === charSequenceLength(this.g6a())) {
      this.k64('EOF');
    }
    if (!(charSequenceGet(this.g6a(), this.d60_1) === _Char___init__impl__6a9atx(34))) {
      this.k64('Expected closing quotation mark');
    }
    this.d60_1 = this.d60_1 + 1 | 0;
  }
  return result;
};
function charToTokenClass(c) {
  var tmp;
  // Inline function 'kotlin.code' call
  if (Char__toInt_impl_vasixd(c) < 126) {
    var tmp_0 = CharMappings_getInstance().o6a_1;
    // Inline function 'kotlin.code' call
    tmp = tmp_0[Char__toInt_impl_vasixd(c)];
  } else {
    tmp = 0;
  }
  return tmp;
}
function tokenDescription(token) {
  return token === 1 ? "quotation mark '\"'" : token === 2 ? "string escape sequence '\\'" : token === 4 ? "comma ','" : token === 5 ? "colon ':'" : token === 6 ? "start of the object '{'" : token === 7 ? "end of the object '}'" : token === 8 ? "start of the array '['" : token === 9 ? "end of the array ']'" : token === 10 ? 'end of the input' : token === 127 ? 'invalid token' : 'valid token';
}
function escapeToChar(c) {
  return c < 117 ? CharMappings_getInstance().n6a_1[c] : _Char___init__impl__6a9atx(0);
}
function initEscape($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 31)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2ESC($this, i, _Char___init__impl__6a9atx(117));
    }
     while (inductionVariable <= 31);
  initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
  initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
  initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
  initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
  initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
  initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
  initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
  initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
}
function initCharToToken($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2TC($this, i, 127);
    }
     while (inductionVariable <= 32);
  initC2TC($this, 9, 3);
  initC2TC($this, 10, 3);
  initC2TC($this, 13, 3);
  initC2TC($this, 32, 3);
  initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
  initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
  initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
  initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
  initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
  initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
  initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
  initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
}
function initC2ESC($this, c, esc) {
  if (!(esc === _Char___init__impl__6a9atx(117))) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
    $this.n6a_1[tmp$ret$0] = numberToChar(c);
  }
}
function initC2ESC_0($this, c, esc) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2ESC($this, tmp$ret$0, esc);
}
function initC2TC($this, c, cl) {
  $this.o6a_1[c] = cl;
}
function initC2TC_0($this, c, cl) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2TC($this, tmp$ret$0, cl);
}
function CharMappings() {
  CharMappings_instance = this;
  this.n6a_1 = charArray(117);
  this.o6a_1 = new Int8Array(126);
  initEscape(this);
  initCharToToken(this);
}
var CharMappings_instance;
function CharMappings_getInstance() {
  if (CharMappings_instance == null)
    new CharMappings();
  return CharMappings_instance;
}
function StringJsonLexerWithComments(source) {
  StringJsonLexer.call(this, source);
}
protoOf(StringJsonLexerWithComments).u65 = function () {
  var source = this.g6a();
  var cpos = this.j6a();
  if (cpos >= source.length || cpos === -1)
    return 10;
  this.d60_1 = cpos + 1 | 0;
  return charToTokenClass(charSequenceGet(source, cpos));
};
protoOf(StringJsonLexerWithComments).q65 = function () {
  var current = this.j6a();
  if (current >= this.g6a().length || current === -1)
    return false;
  return this.k6a(charSequenceGet(this.g6a(), current));
};
protoOf(StringJsonLexerWithComments).d67 = function (expected) {
  var source = this.g6a();
  var current = this.j6a();
  if (current >= source.length || current === -1) {
    this.d60_1 = -1;
    this.l6a(expected);
  }
  var c = charSequenceGet(source, current);
  this.d60_1 = current + 1 | 0;
  if (c === expected)
    return Unit_instance;
  else {
    this.l6a(expected);
  }
};
protoOf(StringJsonLexerWithComments).p65 = function () {
  var source = this.g6a();
  var cpos = this.j6a();
  if (cpos >= source.length || cpos === -1)
    return 10;
  this.d60_1 = cpos;
  return charToTokenClass(charSequenceGet(source, cpos));
};
protoOf(StringJsonLexerWithComments).j6a = function () {
  var current = this.d60_1;
  if (current === -1)
    return current;
  var source = this.g6a();
  $l$loop_1: while (current < source.length) {
    var c = charSequenceGet(source, current);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
      current = current + 1 | 0;
      continue $l$loop_1;
    }
    if (c === _Char___init__impl__6a9atx(47) && (current + 1 | 0) < source.length) {
      var tmp0_subject = charSequenceGet(source, current + 1 | 0);
      if (tmp0_subject === _Char___init__impl__6a9atx(47)) {
        current = indexOf_0(source, _Char___init__impl__6a9atx(10), current + 2 | 0);
        if (current === -1) {
          current = source.length;
        } else {
          current = current + 1 | 0;
        }
        continue $l$loop_1;
      } else if (tmp0_subject === _Char___init__impl__6a9atx(42)) {
        current = indexOf(source, '*/', current + 2 | 0);
        if (current === -1) {
          this.d60_1 = source.length;
          this.k64('Expected end of the block comment: "*/", but had EOF instead');
        } else {
          current = current + 2 | 0;
        }
        continue $l$loop_1;
      }
    }
    break $l$loop_1;
  }
  this.d60_1 = current;
  return current;
};
function StringJsonLexer(source) {
  AbstractJsonLexer.call(this);
  this.y6a_1 = source;
}
protoOf(StringJsonLexer).g6a = function () {
  return this.y6a_1;
};
protoOf(StringJsonLexer).h6a = function (position) {
  return position < this.g6a().length ? position : -1;
};
protoOf(StringJsonLexer).u65 = function () {
  var source = this.g6a();
  var cpos = this.d60_1;
  $l$loop: while (!(cpos === -1) && cpos < source.length) {
    var _unary__edvuaz = cpos;
    cpos = _unary__edvuaz + 1 | 0;
    var c = charSequenceGet(source, _unary__edvuaz);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
      continue $l$loop;
    this.d60_1 = cpos;
    return charToTokenClass(c);
  }
  this.d60_1 = source.length;
  return 10;
};
protoOf(StringJsonLexer).q65 = function () {
  var current = this.d60_1;
  if (current === -1)
    return false;
  var source = this.g6a();
  $l$loop: while (current < source.length) {
    var c = charSequenceGet(source, current);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
      current = current + 1 | 0;
      continue $l$loop;
    }
    this.d60_1 = current;
    return this.k6a(c);
  }
  this.d60_1 = current;
  return false;
};
protoOf(StringJsonLexer).j6a = function () {
  var current = this.d60_1;
  if (current === -1)
    return current;
  var source = this.g6a();
  $l$loop: while (current < source.length) {
    var c = charSequenceGet(source, current);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
      current = current + 1 | 0;
    } else {
      break $l$loop;
    }
  }
  this.d60_1 = current;
  return current;
};
protoOf(StringJsonLexer).d67 = function (expected) {
  if (this.d60_1 === -1) {
    this.l6a(expected);
  }
  var source = this.g6a();
  var cpos = this.d60_1;
  $l$loop: while (cpos < source.length) {
    var _unary__edvuaz = cpos;
    cpos = _unary__edvuaz + 1 | 0;
    var c = charSequenceGet(source, _unary__edvuaz);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
      continue $l$loop;
    this.d60_1 = cpos;
    if (c === expected)
      return Unit_instance;
    this.l6a(expected);
  }
  this.d60_1 = -1;
  this.l6a(expected);
};
protoOf(StringJsonLexer).j67 = function () {
  this.d67(_Char___init__impl__6a9atx(34));
  var current = this.d60_1;
  var closingQuote = indexOf_0(this.g6a(), _Char___init__impl__6a9atx(34), current);
  if (closingQuote === -1) {
    this.s65();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
    var expected = tokenDescription(1);
    var position = false ? this.d60_1 - 1 | 0 : this.d60_1;
    var s = this.d60_1 === charSequenceLength(this.g6a()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.g6a(), position));
    var tmp$ret$0 = 'Expected ' + expected + ", but had '" + s + "' instead";
    this.k64(tmp$ret$0, position);
  }
  var inductionVariable = current;
  if (inductionVariable < closingQuote)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (charSequenceGet(this.g6a(), i) === _Char___init__impl__6a9atx(92)) {
        return this.consumeString2(this.g6a(), this.d60_1, i);
      }
    }
     while (inductionVariable < closingQuote);
  this.d60_1 = closingQuote + 1 | 0;
  // Inline function 'kotlin.text.substring' call
  // Inline function 'kotlin.js.asDynamic' call
  return this.g6a().substring(current, closingQuote);
};
protoOf(StringJsonLexer).l67 = function (keyToMatch, isLenient) {
  var positionSnapshot = this.d60_1;
  try {
    if (!(this.u65() === 6))
      return null;
    var firstKey = this.g67(isLenient);
    if (!(firstKey === keyToMatch))
      return null;
    this.m6a();
    if (!(this.u65() === 5))
      return null;
    return this.g67(isLenient);
  }finally {
    this.d60_1 = positionSnapshot;
    this.m6a();
  }
};
function StringJsonLexer_0(json, source) {
  return !json.p5z_1.q61_1 ? new StringJsonLexer(source) : new StringJsonLexerWithComments(source);
}
function get_schemaCache(_this__u8e3s4) {
  return _this__u8e3s4.r5z_1;
}
function JsonToStringWriter() {
  this.u5z_1 = StringBuilder_init_$Create$_0(128);
}
protoOf(JsonToStringWriter).o63 = function (value) {
  this.u5z_1.jc(value);
};
protoOf(JsonToStringWriter).i63 = function (char) {
  this.u5z_1.c8(char);
};
protoOf(JsonToStringWriter).k63 = function (text) {
  this.u5z_1.b8(text);
};
protoOf(JsonToStringWriter).u63 = function (text) {
  printQuoted(this.u5z_1, text);
};
protoOf(JsonToStringWriter).a28 = function () {
  this.u5z_1.mc();
};
protoOf(JsonToStringWriter).toString = function () {
  return this.u5z_1.toString();
};
function createMapForCache(initialCapacity) {
  return HashMap_init_$Create$(initialCapacity);
}
//region block: post-declaration
protoOf(defer$1).kp = get_isNullable;
protoOf(defer$1).pp = get_isInline;
protoOf(defer$1).rp = get_annotations;
protoOf(JsonSerializersModuleValidator).e18 = contextual;
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Tombstone_instance = new Tombstone();
//endregion
//region block: exports
export {
  Default_getInstance as Default_getInstance3bgzrb1w1dmdh,
  JsonNull_getInstance as JsonNull_getInstance1q6cansbfp6ip,
  JsonArrayBuilder as JsonArrayBuilderu8edol6ui3pj,
  JsonArray as JsonArray2urf8ey7u44sd,
  JsonElement as JsonElementf07o4p6p57al,
  JsonNull as JsonNull2liwjj96vm0w2,
  JsonObjectBuilder as JsonObjectBuilder2nl6rv6vdayuk,
  JsonObject as JsonObjectee06ihoeeiqj,
  JsonPrimitive_0 as JsonPrimitiveolttw629wj53,
  JsonPrimitive_1 as JsonPrimitive2fp8648nd60dn,
  JsonPrimitive_2 as JsonPrimitive1xkjzc5d7ihuv,
  JsonPrimitive as JsonPrimitive3ttzjh2ft5dnx,
  Json_0 as Jsonsmkyu9xjl7fv,
  get_contentOrNull as get_contentOrNull35s97cgi8z9eo,
  get_jsonArray as get_jsonArray18sglwhl4pclz,
};
//endregion

